import React from 'react';
import AppBreadcrumbs from '../../components/AppBreadcrumbs';
import { withRouter } from 'react-router';
import Env from '../../config/env';
import ValidateForm from '../../helpers/ValidateForm';
import GetDataApi from '../../helpers/GetDataApi';
import Session from '../../helpers/Session';
import Api from '../../helpers/Api';
import AppToast from '../../ui/AppToast';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AppInputNumber from '../../ui/AppInputNumber';
import AppInputText from '../../ui/AppInputText';
import AppInputTel from '../../ui/AppInputTel';
import AppInputCel from '../../ui/AppInputCel';
import AppCheckbox from '../../ui/AppCheckbox';
import AppInputDate from '../../ui/AppInputDate';
import OwnerEngineerValidator from '../../components/OwnerEngineerValidator';
import ValidateMinTel from '../../helpers/ValidateMinTel';
import ValidateEmail from '../../helpers/ValidateEmail';
import Alert from '@material-ui/lab/Alert';
import ValidateSizeFile from '../../helpers/ValidateSizeFile';
import { getFileExtension } from '../../helpers/Helpers';
import Redirect from '../../helpers/Redirect';
import Card from '@material-ui/core/Card';
import Icon from '@material-ui/core/Icon';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import Dialog from '@material-ui/core/Dialog';
import GenerarDireccion from './GenerarDireccion';
import Button from '@material-ui/core/Button';
import InformacionPropietario from './InformacionPropietario';
import SearchIcon from '@material-ui/icons/Search';
import rsDepartamento from './resource/departamento';
import rsTipoUso from './resource/tipoUso';
import rsEstratoSocial from './resource/estratoSocial';
import rsTipoSolicitud from './resource/tipoSolicitud';
import rsServicioSolicitado from './resource/servicioSolicitado';
import TableCuentaTipo from './components/cuenta_tipo/index';
import AppTextArea from '../../ui/AppTextArea';
import StoreTemp from '../../store/store_temp';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import economicActivity from '../../assets/data/economic_activity.json';
import nivelTension from './Utils/NivelTension';
import nivelTensionKV from './Utils/NivelTensionKV';
import OwnerEngineerWarning from '../../components/OwnerEngineerWarning';

const initialForm = {
  idSolicitud: {
    key: 'idSolicitud',
    value: null,
  },
  isUpdateCuentaNueva: {
    key: 'isUpdateCuentaNueva',
    value: false,
  },
  tipoCuentaNueva: {
    key: 'tipoCuentaNueva',
    value: '',
    required: true,
    disabled: false,
  },

  // --- FORMULARIO DEL PROPIETARIO ----
  tipoDocumento: {
    key: 'tipoDocumento',
    value: '',
    required: false,
    disabled: false,
  },
  numeroDocumento: {
    key: 'numeroDocumento',
    value: '',
    required: true,
    disabled: false,
  },
  primerNombre: {
    key: 'primerNombre',
    value: '',
    required: true,
    disabled: false,
  },
  segundoNombre: {
    key: 'segundoNombre',
    value: '',
    required: false,
    disabled: false,
  },
  primerApellido: {
    key: 'primerApellido',
    value: '',
    required: true,
    disabled: false,
  },
  segundoApellido: {
    key: 'segundoApellido',
    value: '',
    required: false,
    disabled: false,
  },
  email: {
    key: 'email',
    value: '',
    required: true,
    disabled: false,
  },
  telefono: {
    key: 'telefono',
    value: '',
    required: false,
    disabled: false,
  },
  celular: {
    key: 'celular',
    value: '',
    required: false,
    disabled: false,
  },
  direccion: {
    key: 'direccion',
    value: '',
    required: true,
    disabled: false,
  },
  tipoPersonaPropietario: {
    key: 'tipoPersonaPropietario',
    value: '',
    required: false,
  },
  razonSocialPropietario: {
    key: 'razonSocialPropietario',
    value: '',
    required: false,
    disabled: true,
  },
  departamentoPropietario: {
    key: 'departamentoPropietario',
    value: '',
    required: true,
    disabled: false,
  },
  municipioPropietario: {
    key: 'municipioPropietario',
    value: '',
    required: true,
    disabled: false,
  },
  autorizaNotificacionPropietario: {
    key: 'autorizaNotificacionPropietario',
    value: false,
    required: true,
  },
  propietarioPropietario: {
    key: 'propietarioPropietario',
    value: false,
    required: false,
  },
  // ---------------------------------------

  // --- FORMULARIO DEL ELECTRICISTA -------
  tipoDocumentoElectricista: {
    key: 'tipoDocumentoElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  tipoPersonaElectricista: {
    key: 'tipoPersonaElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  numeroDocumentoElectricista: {
    key: 'numeroDocumentoElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  primerNombreElectricista: {
    key: 'primerNombreElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  segundoNombreElectricista: {
    key: 'segundoNombreElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  primerApellidoElectricista: {
    key: 'primerApellidoElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  segundoApellidoElectricista: {
    key: 'segundoApellidoElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  numeroTarjetaProfesionalElectricista: {
    key: 'numeroTarjetaProfesionalElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  emailElectricista: {
    key: 'emailElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  telefonoElectricista: {
    key: 'telefonoElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  celularElectricista: {
    key: 'celularElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  direccionElectricista: {
    key: 'direccionElectricista',
    value: '',
    required: true,
    disabled: false,
  },
  razonSocialElectri: {
    key: 'razonSocialElectri',
    value: '',
    required: false,
    disabled: false,
  },
  departamentoElectricista: {
    key: 'departamentoElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  municipioElectricista: {
    key: 'municipioElectricista',
    value: '',
    required: false,
    disabled: false,
  },
  // ---------------------------------------

  // ---------- INFO SOLICITUD -------------
  codigoProyecto: {
    key: 'codigoProyecto',
    value: '',
    required: false,
  },
  radicadoProyecto: {
    key: 'radicadoProyecto',
    value: '',
    required: false,
  },
  nombreProyecto: {
    key: 'nombreProyecto',
    value: '',
    required: true,
  },
  proyectoEtapa: {
    key: 'proyectoEtapa',
    value: '',
    required: false,
  },
  municipioUbicacion: {
    key: 'municipioUbicacion',
    value: '',
    required: true,
  },
  direccionUbicacion: {
    key: 'direccionUbicacion',
    value: '',
    required: true,
  },
  zona: {
    key: 'zona',
    value: '',
    required: true,
  },
  kva: {
    key: 'kva',
    value: '',
    required: true,
  },
  kv: {
    key: 'kv',
    value: '',
    required: true,
  },
  nivelTension: {
    key: 'nivelTension',
    value: '',
    required: true,
    disabled: true,
  },
  nodoConexion: {
    key: 'nodoConexion',
    value: '',
    required: true,
  },
  codigoTransformador: {
    key: 'codigoTransformador',
    value: '',
    required: true,
  },
  numeroMedidor: {
    key: 'numeroMedidor',
    value: '',
    required: false,
  },
  tipoZona: {
    key: 'tipoZona',
    value: '',
    required: true,
  },
  // ---------------------------------------
  geolocalizacion: {
    key: 'geolocalizacion',
    value: '',
    required: false,
  },

  incluyeSistemaGeneracion: {
    key: 'incluyeSistemaGeneracion',
    value: '',
    required: false,
  },
  certificacionRETIE: {
    key: 'certificacionRETIE',
    value: '',
    required: false,
  },

  //DATOS DEL PREDIO
  niu: {
    key: 'niu',
    value: '',
    required: false,
  },
  comuna: {
    key: 'comuna',
    value: '',
    required: false,
  },
  departamentoUbicacion: {
    key: 'departamentoUbicacion',
    value: '',
    required: true,
  },
  direccionPredio: {
    key: 'direccionPredio',
    value: '',
    required: false,
  },
  geoPredio: {
    key: 'geoPredio',
    value: '',
    required: true,
  },
  matriculaPredio: {
    key: 'matriculaPredio',
    value: '',
    required: true,
  },
  isEdificacionExistente: {
    key: 'isEdificacionExistente',
    value: '',
    required: true,
  },
  indicacionPredio: {
    key: 'indicacionPredio',
    value: '',
    required: true,
  },
  //TIPO DE USO Y ACTIVIDAD ECONOMICA
  actividadEconomica: {
    key: 'actividadEconomica',
    value: '',
    required: false,
  },
  estrato: {
    key: 'estrato',
    value: '',
    required: true,
    disabled: false,
  },
  tipoUso: {
    key: 'tipoUso',
    value: '',
    required: true,
  },
  otroTipoUso: {
    key: 'otroTipoUso',
    value: '',
    required: false,
  },
  //Datos de infraestructura eléctrica actual conexiones sencillas
  redCercana: {
    key: 'redCercana',
    value: '',
    required: false,
  },
  cuentaVecina: {
    key: 'cuentaVecina',
    value: '',
    required: false,
  },
  distanciaRed: {
    key: 'distanciaRed',
    value: '',
    required: false,
  },
  transfoCercano: {
    key: 'transfoCercano',
    value: '',
    required: false,
  },
  nodeCercano: {
    key: 'nodeCercano',
    value: '',
    required: false,
  },
  //Detalle Servicio
  tipoSolicitud: {
    key: 'tipoSolicitud',
    value: '',
    required: false,
  },
  numSolicitud: {
    key: 'numSolicitud',
    value: '',
    required: false,
  },
  vigenciaSolicitud: {
    key: 'vigenciaSolicitud',
    value: '',
    required: false,
  },
  tipoServicio: {
    key: 'tipoServicio',
    value: '',
    required: false,
  },
  tipoServicioOtro: {
    key: 'tipoServicioOtro',
    value: '',
    required: false,
  },
  cargaKVA: {
    key: 'cargaKVA',
    value: '',
    required: false,
  },
  cargaKVAMax: {
    key: 'cargaKVAMax',
    value: '',
    required: false,
  },
  nivelTensionSolicitado: {
    key: 'nivelTensionSolicitado',
    value: '',
    required: false,
  },
  tipoMedidor: {
    key: 'tipoMedidor',
    value: '',
    required: false,
  },
  tipoMedida: {
    key: 'tipoMedida',
    value: '',
    required: false,
  },
  tipoAcometida: {
    key: 'tipoAcometida',
    value: '',
    required: false,
  },
  fechaEntradaOperacion: {
    key: 'fechaEntradaOperacion',
    value: '', //new Date().getFullYear() + '-01-01'
    required: true,
  },
  marcaMedidior: {
    key: 'marcaMedidior',
    value: '',
    required: false,
  },
  //CHEK AUTORIZACION
  autorizaDatosPersonales: {
    key: 'autorizaDatosPersonales',
    value: false,
    required: true,
  },
  autorizaConexion: {
    key: 'autorizaConexion',
    value: false,
    required: true,
  },
  //OBSERVACION
  observacion: {
    key: 'observacion',
    value: '',
    required: false,
  },
  //TABLA
  registrocuentatipo: {
    key: 'registrocuentatipo',
    value: '',
    required: false,
    disabled: false,
  },
};

const location = {
  tipoZona: [
    { value: 'U', detalle: 'Urbana' },
    { value: 'R', detalle: 'Rural' },
  ],
};

const seccions = {
  applicationInformation: {
    key: 'applicationInformation',
    value: true,
    description: 'Información de la solicitud',
  },
  siteInformation: {
    key: 'siteInformation',
    value: true,
    description: 'Datos del Predio',
  },
  typesUse: {
    key: 'typesUse',
    value: true,
    description: 'Tipos de uso y actividad económica',
  },
  infrastructureData: {
    key: 'infrastructureData',
    value: true,
    description: 'Datos de infraestructura eléctrica actual conexiones sencillas',
  },
  serviceDetail: {
    key: 'serviceDetail',
    value: true,
    description: 'Detalle del Servicio',
  },
};

class CuentaNuevaForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadData: {
        documentTypes: [],
        tipos: [],
        zonas: [],
        nivelesTension: [],
        tipoSolicitud: [],
        servicioSolicitado: [],
        tipoUso: [],
        estratoSocial: [],
        tipoMedidor: [],
        tipoAcometida: [],
        departamento: [],
        departamento_predio: [],
        municipio: [],
        tipoMedida: [],
      },
      pasoID: null,
      form: initialForm,
      documentosAdjuntos: [],
      fileAutorizacionPropietario: null,
      fileCedulaElectricista: null,
      fileTarjetaProfesionalElectricista: null,
      latlng: { lat: null, lng: null },
      tipoUsuario: null,
      openDialog: false,
      currentKey: '',
      municipioSelected: '',
      departamento: rsDepartamento,
      departamento_predio: [],
      municipios: [],
      tmpMunicipios: [],
      existePropietario: false,
      existeElectricista: false,
      url: '',
      municipiosDepartamento: [],
      municipiosPredio: [],
      isVisibleOtroTipoUso: false,
      isVisibleExistTipoSolicitud: false,
      isVisibleOtroServicioSol: false,
      isVisibleLinkGREG: false,
      seccions: seccions,
    };

    this.setLatLng = this.setLatLng.bind(this);
    this.setDireccion = this.setDireccion.bind(this);
  }

  async componentDidMount() {
    this.setState({ tipoUsuario: this.props.match.params.tipoUsuario });
    this.loadForm();
  }

  initForm() {
    this.setState({
      form: initialForm,
    });
  }

  getDocumentTypes = async () => {
    const data = await Api.get(`${Env.UrlSeguridad}/getDocumentoTipo`);
    if (data.cod === '1') {
      this.setState({
        loadData: {
          ...this.state.loadData,
          documentTypes: data.DocumentoTipo,
        },
      });
    } else {
      AppToast(data.message, false);
    }
  };

  loadControls = async () => {
    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud/load-controls`);
    if (response.success) {
      this.setState({
        loadData: {
          ...this.state.loadData,
          tipos: response.data.tipos,
          zonas: response.data.zonas,
          nivelesTension: response.data.nivelesTension,
          tipoUso: response.data.tipo_uso,
          estratoSocial: response.data.estrato_social,
          tipoSolicitud: response.data.tipo_solicitud,
          servicioSolicitado: response.data.tipo_servicio_solicitado,
          tipoAcometida: response.data.tipo_acometida,
          tipoMedidor: response.data.tipo_medidor,
          departamento: response.data.departamento,
          departamento_predio: response.data.departamento_predio,
          tipoMedida: response.data.tipo_medida,
        },
      });
    } else {
      AppToast(response.message, false);
    }
  };

  //INIT
  loadForm = async () => {
    await this.getDocumentTypes();
    await this.loadControls();
    await this.getCities();
    await this.disabledRolPropietario();

    const userData = Session.getLogin();

    switch (this.state.tipoUsuario) {
      case Env.tipoUsuario.propietario:
        this.setState({
          form: {
            ...this.state.form,
            tipoDocumento: {
              ...this.state.form.tipoDocumento,
              value: userData.documentoTipoID,
              disabled: true,
            },
            numeroDocumento: {
              ...this.state.form.numeroDocumento,
              value: userData.terceroDocumento,
              required: false,
              disabled: true,
            },
            primerNombre: {
              ...this.state.form.primerNombre,
              value: userData.terceroNombre1,
              disabled: true,
              required: false,
            },
            segundoNombre: {
              ...this.state.form.segundoNombre,
              value: userData.terceroNombre2,
              disabled: true,
              required: false,
            },
            primerApellido: {
              ...this.state.form.primerApellido,
              value: userData.terceroApellido1,
              disabled: true,
              required: false,
            },
            segundoApellido: {
              ...this.state.form.segundoApellido,
              value: userData.terceroApellido2,
              disabled: true,
              required: false,
            },
            email: {
              ...this.state.form.email,
              value: userData.terceroMail,
              disabled: true,
              required: false,
            },
            telefono: {
              ...this.state.form.telefono,
              value: userData.terceroTel,
              disabled: true,
            },
            celular: {
              ...this.state.form.celular,
              value: userData.terceroCel,
              disabled: true,
              required: false,
            },
            direccion: {
              ...this.state.form.direccion,
              value: userData.terceroDireccion,
              disabled: true,
              required: false,
            },
          },
        });
        break;
      //CARGAR INFORMACION ELECTICISTA
      case Env.tipoUsuario.electricista:
        await this.getDataElectricista(userData.terceroDocumento);
        this.selectTipoPersonaElectricista(this.state.form.tipoDocumentoElectricista);
        this.setState({
          form: {
            ...this.state.form,
            tipoDocumentoElectricista: {
              ...this.state.form.tipoDocumentoElectricista,
              value: userData.documentoTipoID,
              disabled: true,
            },
            numeroDocumentoElectricista: {
              ...this.state.form.numeroDocumentoElectricista,
              value: userData.terceroDocumento,
              disabled: true,
            },
            primerNombreElectricista: {
              ...this.state.form.primerNombreElectricista,
              value: userData.terceroNombre1,
              disabled: true,
            },
            segundoNombreElectricista: {
              ...this.state.form.segundoNombreElectricista,
              value: userData.terceroNombre2 ? userData.terceroNombre2 : '',
              disabled: true,
              required: false,
            },
            primerApellidoElectricista: {
              ...this.state.form.primerApellidoElectricista,
              value: userData.terceroApellido1,
              disabled: true,
            },
            segundoApellidoElectricista: {
              ...this.state.form.segundoApellidoElectricista,
              value: userData.terceroApellido2 ? userData.terceroApellido2 : '',
              disabled: true,
              required: false,
            },
            emailElectricista: {
              ...this.state.form.emailElectricista,
              value: userData.terceroMail,
              disabled: true,
            },
            telefonoElectricista: {
              ...this.state.form.telefonoElectricista,
              value: userData.terceroTel ? userData.terceroTel : '',
              disabled: true,
            },
            celularElectricista: {
              ...this.state.form.celularElectricista,
              value: userData.terceroCel ? userData.terceroCel : '',
              disabled: true,
            },
            direccionElectricista: {
              ...this.state.form.direccionElectricista,
              value: userData.terceroDireccion,
              disabled: true,
            },
            /*tipoPersona: {
              ...this.state.form.tipoPersona,
              value: userData.tipoPersona,
              disabled: false,
            },*/
            razonSocialElectri: {
              ...this.state.form.razonSocialElectri,
              value: userData.razonSocialElectri,
              disabled: true,
              required: false,
            },
            departamentoElectricista: {
              ...this.state.form.departamentoElectricista,
              value: userData.departamentoElectricista,
              disabled: false,
            },
            municipioElectricista: {
              ...this.state.form.municipioElectricista,
              value: userData.municipioElectricista,
              disabled: false,
            },
          },
        });

        break;
      default:
        break;
    }

    //DATA PARA ACTUALIZAR
    this.getDataUpdate();
  };

  getDataUpdate = async () => {
    let data = StoreTemp.get('solicitud');

    if (data != null) {
      this.selectTipoPersona(this.selectTipoPersonaElectricista(data['usuario']['tipo_documento']['codigo_externo']));
      this.selectTipoPersonaElectricista(data['electricista']['tipo_documento']['codigo_externo']);

      await this.getMunicipio(data['electricista']['departamento_id']);

      this.setState({
        form: {
          ...this.state.form,
          //ELECTRICISTA
          tipoDocumentoElectricista: {
            ...this.state.form.tipoDocumentoElectricista,
            value: data['electricista']['tipo_documento']['codigo_externo'],
            disabled: true,
          },
          numeroDocumentoElectricista: {
            ...this.state.form.numeroDocumentoElectricista,
            value: data['electricista']['numero_documento'],
            disabled: true,
          },
          numeroTarjetaProfesionalElectricista: {
            ...this.state.form.numeroTarjetaProfesionalElectricista,
            value: data['electricista']['numero_tarjeta_prof'],
            disabled: true,
          },
          primerNombreElectricista: {
            ...this.state.form.primerNombreElectricista,
            value: data['electricista']['primer_nombre'],
            disabled: true,
          },
          segundoNombreElectricista: {
            ...this.state.form.segundoNombreElectricista,
            value: data['electricista']['segundo_nombre'],
            disabled: true,
            required: false,
          },
          primerApellidoElectricista: {
            ...this.state.form.primerApellidoElectricista,
            value: data['electricista']['primer_apellido'],
            disabled: true,
          },
          segundoApellidoElectricista: {
            ...this.state.form.segundoApellidoElectricista,
            value: data['electricista']['segundo_apellido'],
            disabled: true,
            required: false,
          },
          razonSocialElectri: {
            ...this.state.form.razonSocialElectri,
            value: data['electricista']['razon_social'],
            disabled: true,
            required: false,
          },
          emailElectricista: {
            ...this.state.form.emailElectricista,
            value: data['electricista']['email'],
            disabled: true,
          },
          telefonoElectricista: {
            ...this.state.form.telefonoElectricista,
            value: data['electricista']['telefono'],
            disabled: true,
          },
          celularElectricista: {
            ...this.state.form.celularElectricista,
            value: data['electricista']['celular'],
            disabled: true,
          },
          direccionElectricista: {
            ...this.state.form.direccionElectricista,
            value: data['electricista']['direccion'],
            disabled: true,
          },
          departamentoElectricista: {
            ...this.state.form.departamentoElectricista,
            value: data['electricista']['departamento_id'],
            disabled: true,
          },
          municipioElectricista: {
            ...this.state.form.municipioElectricista,
            value: data['electricista']['municipio_id'],
            disabled: true,
          },
          //PROPIETARIO
          tipoDocumento: {
            ...this.state.form.tipoDocumento,
            value: data['usuario']['tipo_documento']['codigo_externo'],
            disabled: true,
          },
          numeroDocumento: {
            ...this.state.form.numeroDocumento,
            value: data['usuario']['numero_documento'],
            disabled: true,
          },
          razonSocialPropietario: {
            ...this.state.form.razonSocialPropietario,
            value: data['usuario']['razon_social'],
            disabled: true,
          },
          primerNombre: {
            ...this.state.form.primerNombre,
            value: data['usuario']['primer_nombre'],
            disabled: true,
          },
          segundoNombre: {
            ...this.state.form.segundoNombre,
            value: data['usuario']['segundo_nombre'],
            disabled: true,
            required: false,
          },
          primerApellido: {
            ...this.state.form.primerApellido,
            value: data['usuario']['primer_apellido'],
            disabled: true,
          },
          segundoApellido: {
            ...this.state.form.segundoApellido,
            value: data['usuario']['segundo_apellido'],
            disabled: true,
            required: false,
          },
          email: {
            ...this.state.form.email,
            value: data['usuario']['email'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxCorreo'),
          },
          telefono: {
            ...this.state.form.telefono,
            value: data['usuario']['telefono'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTelefono'),
          },
          celular: {
            ...this.state.form.celular,
            value: data['usuario']['celular'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxCelular'),
          },
          direccion: {
            ...this.state.form.direccion,
            value: data['usuario']['direccion'],
            disabled: true,
          },
          departamentoPropietario: {
            ...this.state.form.departamentoPropietario,
            value: data['usuario']['departamento_id'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxDepartamento'),
          },
        },
      });

      //SOLICITUD
      this.setState({
        form: {
          ...this.state.form,
          direccion: {
            ...this.state.form.direccion,
            disabled: this.getDisabledForm(data['validateform'], 'chbxDireccionCorrespondencia'),
          },
          idSolicitud: {
            ...this.state.form.idSolicitud,
            value: data['id'],
          },
          isUpdateCuentaNueva: {
            ...this.state.form.isUpdateCuentaNueva,
            value: true,
          },
          tipoCuentaNueva: {
            ...this.state.form.tipoCuentaNueva,
            value: data['tipo']['id'],
            disabled: true,
          },
          //
          codigoProyecto: {
            ...this.state.form.codigoProyecto,
            value: data['codigo_proyecto'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxCodigoProyecto'),
          },
          nombreProyecto: {
            ...this.state.form.nombreProyecto,
            value: data['nombre_proyecto'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNombreProyecto'),
          },
          nivelTension: {
            ...this.state.form.nivelTension,
            value: data['nivel_tension_id'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNivelTension'),
          },
          kva: {
            ...this.state.form.kva,
            value: data['kva'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxExistenteKVA'),
          },
          direccionUbicacion: {
            ...this.state.form.direccionUbicacion,
            value: data['direccion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxDireccionPredio'),
          },
          nodoConexion: {
            ...this.state.form.nodoConexion,
            value: data['nodo_conexion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNodeConexion'),
          },
          codigoTransformador: {
            ...this.state.form.codigoTransformador,
            value: data['codigo_transformador'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNumeroTransformador'),
          },
          //DATOS PREDIO
          tipoZona: {
            ...this.state.form.tipoZona,
            value: data['tipozona'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxZona'), //OJO
          },
          zona: {
            ...this.state.form.zona,
            value: data['zona']['id'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxZona'),
          },
          niu: {
            ...this.state.form.niu,
            value: data['niu'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNIU'),
          },
          comuna: {
            ...this.state.form.comuna,
            value: data['comuna'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxComuna'),
          },
          departamentoUbicacion: {
            ...this.state.form.departamentoUbicacion,
            value: data['departamentoubicacion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxDepartamentoPredio'),
          },
          direccionPredio: {
            ...this.state.form.direccionPredio,
            value: data['direccion'],
          },
          geoPredio: {
            ...this.state.form.geoPredio,
            value: data['geopredio'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxGeoPredio'),
          },
          matriculaPredio: {
            ...this.state.form.matriculaPredio,
            value: data['matriculapredio'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxMatriculaPredio'),
          },
          isEdificacionExistente: {
            ...this.state.form.isEdificacionExistente,
            value: data['isedificacionexistente'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxEdificacionExistentePredio'),
          },
          indicacionPredio: {
            ...this.state.form.indicacionPredio,
            value: data['indicacionpredio'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxIndicacionesPredio'),
          },
          //Tipos de uso y actividad económica
          tipoUso: {
            ...this.state.form.tipoUso,
            value: data['tipouso'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoUso'),
          },
          otroTipoUso: {
            ...this.state.form.otroTipoUso,
            value: data['otrotipouso'],
            disabled: true,
          },
          estrato: {
            ...this.state.form.estrato,
            value: data['estrato'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoEstratoSocio'),
          },
          actividadEconomica: {
            ...this.state.form.actividadEconomica,
            value: data['actividadeconomica'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoActividadEcono'),
          },
          //Datos de infraestructura eléctrica actual conexiones sencillas
          redCercana: {
            ...this.state.form.redCercana,
            value: data['redcercana'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxHayRedElectrica'),
          },
          cuentaVecina: {
            ...this.state.form.cuentaVecina,
            value: data['cuentavecina'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxCuentaVecina'),
          },
          distanciaRed: {
            ...this.state.form.distanciaRed,
            value: data['distanciared'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxDistanciaRedCercana'),
          },
          transfoCercano: {
            ...this.state.form.transfoCercano,
            value: data['codigo_transformador'],
          },
          nodeCercano: {
            ...this.state.form.nodeCercano,
            value: data['nodo_conexion'],
          },
          //Detalle del Servicio
          proyectoEtapa: {
            ...this.state.form.proyectoEtapa,
            value: data['proyectoetapa'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxProyectoEtapa'),
          },
          tipoSolicitud: {
            ...this.state.form.tipoSolicitud,
            value: data['tiposolicitud'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoSolicitud'),
          },
          numSolicitud: {
            ...this.state.form.numSolicitud,
            value: data['numsolicitud'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNumeroSolicitud'),
          },
          vigenciaSolicitud: {
            ...this.state.form.vigenciaSolicitud,
            value: data['vigenciasolicitud'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxVigencia'),
          },
          tipoServicio: {
            ...this.state.form.tipoServicio,
            value: data['tiposervicio'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoSolicitud'),
          },
          cargaKVA: {
            ...this.state.form.cargaKVA,
            value: data['cargakva'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxExistenteKVA'),
          },
          cargaKVAMax: {
            ...this.state.form.cargaKVAMax,
            value: data['kva'],
          },
          nivelTensionSolicitado: {
            ...this.state.form.nivelTensionSolicitado,
            value: data['nivel_tension_id'],
          },
          numeroMedidor: {
            ...this.state.form.numeroMedidor,
            value: data['numero_medidor'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxNumeroMedidor'),
          },
          marcaMedidior: {
            ...this.state.form.marcaMedidior,
            value: data['marcamedidior'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxMarca'),
          },
          tipoMedidor: {
            ...this.state.form.tipoMedidor,
            value: data['tipomedidor'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoMedidor'),
          },
          tipoAcometida: {
            ...this.state.form.tipoAcometida,
            value: data['tipoacometida'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoAcometida'),
          },
          fechaEntradaOperacion: {
            ...this.state.form.fechaEntradaOperacion,
            value: data['fechaentradaoperacion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxFechaEntradaOperacion'),
          },
          incluyeSistemaGeneracion: {
            ...this.state.form.incluyeSistemaGeneracion,
            value: data['incluyesistemageneracion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxSistemaAutogeneracion'),
          },
          observacion: {
            ...this.state.form.observacion,
            value: data['incluyesistemageneracion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxObservacion'),
          },
          registrocuentatipo: {
            ...this.state.form.registrocuentatipo,
            value: data['registrocuentatipo'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxInformacionTabla'),
          },
          certificacionRETIE: {
            ...this.state.form.certificacionRETIE,
            value: data['retie'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxRetie'),
          },
          tipoMedida: {
            ...this.state.form.tipoMedida,
            value: data['tipomedida'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxTipoMedida'),
          },
        },
      });

      await this.getMunicipioPredio(data['departamentoubicacion']);
      await this.selectDepartamentoPropietario(data['usuario']['departamento_id']);

      this.setState({
        form: {
          ...this.state.form,
          municipioUbicacion: {
            ...this.state.form.municipioUbicacion,
            value: data['municipioubicacion'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxMunicipioPredio'),
          },
          municipioPropietario: {
            ...this.state.form.municipioPropietario,
            value: data['usuario']['municipio_id'],
            disabled: this.getDisabledForm(data['validateform'], 'chbxMunicipio'),
          },
        },
      });
    }
  };

  getDisabledForm = (data, key) => {
    const result = JSON.parse(data);
    const item = result.find((b) => b.key === key);
    return !item ? true : item.value;
  };

  disabledRolPropietario = async () => {
    if (this.state.tipoUsuario === Env.tipoUsuario.propietario) {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            departamentoPropietario: {
              ...this.state.form.departamentoPropietario,
              required: false,
              disabled: true,
            },
            municipioPropietario: {
              ...this.state.form.municipioPropietario,
              required: false,
              disabled: true,
            },
            primerNombreElectricista: {
              ...this.state.form.primerNombreElectricista,
              required: false,
              disabled: true,
            },
            segundoNombreElectricista: {
              ...this.state.form.segundoNombreElectricista,
              required: false,
              disabled: true,
            },
            primerApellidoElectricista: {
              ...this.state.form.primerApellidoElectricista,
              required: false,
              disabled: true,
            },
            segundoApellidoElectricista: {
              ...this.state.form.segundoApellidoElectricista,
              required: false,
              disabled: true,
            },
            emailElectricista: {
              ...this.state.form.emailElectricista,
              required: false,
              disabled: true,
            },
            telefonoElectricista: {
              ...this.state.form.telefonoElectricista,
              required: false,
              disabled: true,
            },
            celularElectricista: {
              ...this.state.form.celularElectricista,
              required: false,
              disabled: true,
            },
            direccionElectricista: {
              ...this.state.form.direccionElectricista,
              required: false,
              disabled: true,
            },
            razonSocialElectri: {
              ...this.state.form.razonSocialElectri,
              required: false,
              disabled: true,
            },
            departamentoElectricista: {
              ...this.state.form.departamentoElectricista,
              required: false,
              disabled: false,
            },
            municipioElectricista: {
              ...this.state.form.municipioElectricista,
              required: false,
              disabled: false,
            },
          },
        };
      });
    }
  };

  setLatLng = (lat, lng) => {
    this.setState({
      latlng: {
        lat: lat,
        lng: lng,
      },
    });
  };

  handleChangeFiles = (e, tipo) => {
    const selectorFiles = e.target.files;
    let file = null;
    if (selectorFiles.length > 0) {
      file = selectorFiles[0];
    }

    if (!ValidateSizeFile(file)) {
      AppToast(`El tamaño permitido es de ${Env.AllowedSize} megas`, false);
      this.setState({
        [tipo]: null,
      });
      e.target.value = '';
      return false;
    }

    const fileExtension = getFileExtension(file.name);
    if (fileExtension !== 'pdf') {
      AppToast(`El archivo adjunto debe ser un pdf.`, false);
      this.setState({
        [tipo]: null,
      });
      e.target.value = '';
      return false;
    }

    this.setState({
      [tipo]: file,
    });
  };

  handleChangeFilesDinamic = (e, val) => {
    const selectorFiles = e.target.files;
    let file = null;
    if (selectorFiles.length > 0) {
      file = selectorFiles[0];
    } else {
      return;
    }

    if (!ValidateSizeFile(file, val.tamanio)) {
      AppToast(`El tamaño permitido es de ${val.tamanio} megas`, false);
      e.target.value = '';
      return false;
    }

    const fileExtension = getFileExtension(file.name);
    const extensiones = val.tipos.split(',');
    if (!extensiones.includes(fileExtension)) {
      AppToast(`Solo se puede adjuntar documentos de tipo: ${val.tipos}.`, false);
      e.target.value = '';
      return false;
    }

    val.archivo = file;
  };

  keyPress = async (e, tipoEvento = 'keyPress') => {
    if (e.keyCode === 13 || tipoEvento === 'onBlur') {
      e.preventDefault();

      const { value, name } = e.target;

      switch (name) {
        case this.state.form.numeroDocumento.key:
          await this.getDataPropietario(value);
          break;
        case this.state.form.numeroDocumentoElectricista.key:
          if (this.state.tipoUsuario === Env.tipoUsuario.propietario) {
            await this.getDataElectricista(value, this.state.form.numeroTarjetaProfesionalElectricista.value, true);
          }
          break;
        case this.state.form.numeroTarjetaProfesionalElectricista.key:
          if (this.state.tipoUsuario === Env.tipoUsuario.propietario) {
            this.setState((statePrev) => {
              return {
                form: {
                  ...statePrev.form,
                  departamentoPropietario: {
                    ...this.state.form.departamentoPropietario,
                    required: false,
                    disabled: true,
                  },
                  municipioPropietario: {
                    ...this.state.form.municipioPropietario,
                    required: false,
                    disabled: true,
                  },
                },
              };
            });
            await this.getDataElectricista(this.state.form.numeroDocumentoElectricista.value, value, true);
          }
          break;
        default:
          break;
      }
    }
  };

  handleChange = async (e) => {
    const valueText = e.nativeEvent.target.innerText;
    const { value, name } = e.target;

    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });
    switch (name) {
      case this.state.form.tipoCuentaNueva.key:
        await this.getDocumentosAdjuntos(value);
        await this.configureForm(value);
        await nivelTension(value, this);
        await nivelTensionKV(this.state.form.tipoCuentaNueva.value, this.state.form.kv.value, this);
        break;
      case this.state.form.municipioUbicacion.key:
        // this.actualizarDireccionMapa(
        //   this.state.form.direccionUbicacion.value,
        //   valueText
        // );
        this.setState({ municipioSelected: valueText });
        break;
      case this.state.form.zona.key:
        this.validarZona(value);
        break;
      case this.state.form.departamentoElectricista.key:
        this.getMunicipio(value);
        break;
      case this.state.form.departamentoUbicacion.key:
        this.getMunicipioPredio(value);
        break;
      case this.state.form.tipoUso.key:
        this.optionTipoUso(value);
        break;
      case this.state.form.tipoSolicitud.key:
        this.optionTipoSolicitud(value);
        break;
      case this.state.form.tipoServicio.key:
        this.optionTipoServicio(value);
        break;
      case this.state.form.incluyeSistemaGeneracion.key:
        this.optionSistemaGeneracion(value);
        break;
      case this.state.form.tipoDocumento.key:
        this.selectTipoPersona(value);
        break;
      case this.state.form.tipoDocumentoElectricista.key:
        this.selectTipoPersonaElectricista(value);
        break;
      case this.state.form.departamentoPropietario.key:
        this.selectDepartamentoPropietario(value);
        break;
      case this.state.form.proyectoEtapa.key:
        this.selectProyectoEtapa(value);
        break;
      case this.state.form.kv.key:
        await nivelTensionKV(this.state.form.tipoCuentaNueva.value, value, this);
        break;
      case this.state.form.nivelTension.key:
        await nivelTensionKV(this.state.form.tipoCuentaNueva.value, this.state.form.kv.value, this);
        break;
      default:
        break;
    }
  };

  handleActividadEconomicaChange = async (e) => {
    const valueText = e.nativeEvent.target.innerText;
    this.setState({
      form: {
        ...this.state.form,
        actividadEconomica: {
          ...this.state.form.actividadEconomica,
          value: valueText,
        },
      },
    });
  };

  handleChangeCheck = async (e) => {
    // const valueText = e.nativeEvent.target.checked;
    const { checked, name } = e.target;
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: checked,
          },
        },
      };
    });
  };

  validarZona = (zonaId) => {
    const zona = this.state.loadData.zonas.find((data) => data.id === zonaId);

    const cities = this.state.tmpMunicipios.filter((data) => data.zona === zona.zona_siec);
    this.setState({ municipios: cities });
    this.setState({ municipioSelected: '' });

    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          municipioUbicacion: {
            ...statePrev.form.municipioUbicacion,
            value: '',
          },
        },
      };
    });
  };

  getDataPropietario = async (numeroDocumento) => {
    if (numeroDocumento === null || numeroDocumento === '') {
      return;
    }

    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/usuario/get-by-numero-documento?numero_documento=${numeroDocumento}&tipo_usuario=PROPI`);
    if (!response.success) {
      AppToast(response.message, false);
    }
    if (response.data) {
      const data = response.data;

      await this.selectDepartamentoPropietario(data.departamento_id);

      this.setState({
        existePropietario: true,
        form: {
          ...this.state.form,
          tipoDocumento: {
            ...this.state.form.tipoDocumento,
            value: data.tipo_documento.codigo_externo,
            disabled: true,
          },
          numeroDocumento: {
            ...this.state.form.numeroDocumento,
            value: data.numero_documento,
            disabled: true,
          },
          primerNombre: {
            ...this.state.form.primerNombre,
            value: data.primer_nombre,
            disabled: true,
          },
          segundoNombre: {
            ...this.state.form.segundoNombre,
            value: data.segundo_nombre,
            disabled: true,
            required: false,
          },
          primerApellido: {
            ...this.state.form.primerApellido,
            value: data.primer_apellido,
            disabled: true,
          },
          segundoApellido: {
            ...this.state.form.segundoApellido,
            value: data.segundo_apellido,
            disabled: true,
            required: false,
          },
          email: {
            ...this.state.form.email,
            value: data.email,
            disabled: true,
          },
          telefono: {
            ...this.state.form.telefono,
            value: data.telefono,
            disabled: true,
          },
          celular: {
            ...this.state.form.celular,
            value: data.celular,
            disabled: true,
          },
          direccion: {
            ...this.state.form.direccion,
            value: data.direccion,
            disabled: true,
          },
          departamentoPropietario: {
            ...this.state.form.departamentoPropietario,
            value: data.departamento_id,
          },
          municipioPropietario: {
            ...this.state.form.municipioPropietario,
            value: data.municipio_id,
          },
          razonSocialPropietario: {
            ...this.state.form.razonSocialPropietario,
            value: data.razon_social,
            disabled: true,
            required: false,
          },
        },
      });
    } else {
      this.setState({
        existePropietario: false,
        form: {
          ...this.state.form,
          /* tipoDocumento: {
            ...this.state.form.tipoDocumento,
            value: "",
          },*/
          primerNombre: {
            ...this.state.form.primerNombre,
            value: '',
          },
          segundoNombre: {
            ...this.state.form.segundoNombre,
            value: '',
            required: false,
          },
          primerApellido: {
            ...this.state.form.primerApellido,
            value: '',
          },
          segundoApellido: {
            ...this.state.form.segundoApellido,
            value: '',
            required: false,
          },
          email: {
            ...this.state.form.email,
            value: '',
          },
          telefono: {
            ...this.state.form.telefono,
            value: '',
          },
          celular: {
            ...this.state.form.celular,
            value: '',
          },
          direccion: {
            ...this.state.form.direccion,
            value: '',
          },
        },
      });
    }
  };

  getDataElectricista = async (numeroDocumento = null, matriculaProfesional = null, validate = false) => {
    if (validate) {
      if (numeroDocumento === null || numeroDocumento === '' || matriculaProfesional === null || matriculaProfesional === '') {
        AppToast('Debe ingresar el número de documento y la matrícula');
        return;
      }
    }

    const params = `numero_documento=${numeroDocumento}&matricula_profesional=${matriculaProfesional}&tipo_usuario=ELECT`;
    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/usuario/get-by-numero-documento?${params}`);

    if (response.success) {
      if (response.data) {
        const data = response.data;

        this.setState({
          existeElectricista: true,
          form: {
            ...this.state.form,
            tipoDocumentoElectricista: {
              ...this.state.form.tipoDocumentoElectricista,
              value: data.tipo_documento.codigo_externo,
              disabled: true,
            },
            numeroDocumentoElectricista: {
              ...this.state.form.numeroDocumentoElectricista,
              value: data.numero_documento,
              disabled: true,
            },
            primerNombreElectricista: {
              ...this.state.form.primerNombreElectricista,
              value: data.primer_nombre,
              disabled: true,
            },
            segundoNombreElectricista: {
              ...this.state.form.segundoNombreElectricista,
              value: data.segundo_nombre,
              disabled: true,
              required: false,
            },
            primerApellidoElectricista: {
              ...this.state.form.primerApellidoElectricista,
              value: data.primer_apellido,
              disabled: true,
            },
            segundoApellidoElectricista: {
              ...this.state.form.segundoApellidoElectricista,
              value: data.segundo_apellido,
              disabled: true,
              required: false,
            },
            emailElectricista: {
              ...this.state.form.emailElectricista,
              value: data.email,
              disabled: true,
            },
            numeroTarjetaProfesionalElectricista: {
              ...this.state.form.numeroTarjetaProfesionalElectricista,
              value: data.numero_tarjeta_prof,
              disabled: true,
            },
            telefonoElectricista: {
              ...this.state.form.telefonoElectricista,
              value: data.telefono,
              disabled: true,
            },
            celularElectricista: {
              ...this.state.form.celularElectricista,
              value: data.celular,
              disabled: true,
            },
            direccionElectricista: {
              ...this.state.form.direccionElectricista,
              value: data.direccion,
              disabled: true,
            },
            departamentoElectricista: {
              ...this.state.form.departamentoElectricista,
              disabled: false,
              value: data.departamento_id,
            },
            municipioElectricista: {
              ...this.state.form.municipioElectricista,
              disabled: false,
            },
          },
        });

        this.selectTipoPersonaElectricista(data.tipo_documento.codigo_externo);
      } else {
        this.cleanFormElectricista();
      }
      if (response.electricistaValido) {
        AppToast('¡Electricista válido!', true);
      }
    } else {
      AppToast(response.message, false);

      if (!response.electricistaValido) {
        this.cleanFormElectricista(true);
      }
    }
  };

  cleanFormElectricista = (disabled = false) => {
    this.setState({
      existeElectricista: false,
      form: {
        ...this.state.form,
        /* tipoDocumentoElectricista: {
          ...this.state.form.tipoDocumentoElectricista,
          value: "",
          disabled: disabled,
        },*/
        primerNombreElectricista: {
          ...this.state.form.primerNombreElectricista,
          value: '',
          disabled: disabled,
        },
        segundoNombreElectricista: {
          ...this.state.form.segundoNombreElectricista,
          value: '',
          disabled: disabled,
          required: false,
        },
        primerApellidoElectricista: {
          ...this.state.form.primerApellidoElectricista,
          value: '',
          disabled: disabled,
        },
        segundoApellidoElectricista: {
          ...this.state.form.segundoApellidoElectricista,
          value: '',
          disabled: disabled,
          required: false,
        },
        emailElectricista: {
          ...this.state.form.emailElectricista,
          value: '',
          disabled: disabled,
        },
        telefonoElectricista: {
          ...this.state.form.telefonoElectricista,
          value: '',
          disabled: disabled,
        },
        celularElectricista: {
          ...this.state.form.celularElectricista,
          value: '',
          disabled: disabled,
        },
        direccionElectricista: {
          ...this.state.form.direccionElectricista,
          value: '',
          disabled: disabled,
        },
      },
    });
  };

  configureForm = (value) => {
    //Parametrización Medidores
    this.setState((statePrev) => {
      return {
        seccions: {
          ...statePrev.seccions,
          siteInformation: {
            ...statePrev.siteInformation,
            value: !(value === 17),
          },
          typesUse: {
            ...statePrev.typesUse,
            value: !(value === 17),
          },
          infrastructureData: {
            ...statePrev.infrastructureData,
            value: !(value === 17),
          },
          serviceDetail: {
            ...statePrev.serviceDetail,
            value: !(value === 17),
          },
        },
      };
    });

    if (value === 17) {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            radicadoProyecto: {
              ...this.state.form.radicadoProyecto,
              required: false,
            },
            municipioUbicacion: {
              ...this.state.form.municipioUbicacion,
              required: false,
            },

            tipoZona: {
              ...this.state.form.tipoZona,
              required: false,
            },
            departamentoUbicacion: {
              ...this.state.form.departamentoUbicacion,
              required: false,
            },
            geoPredio: {
              ...this.state.form.geoPredio,
              required: false,
            },
            matriculaPredio: {
              ...this.state.form.matriculaPredio,
              required: false,
            },
            isEdificacionExistente: {
              ...this.state.form.isEdificacionExistente,
              required: false,
            },
            indicacionPredio: {
              ...this.state.form.indicacionPredio,
              required: false,
            },
            actividadEconomica: {
              ...this.state.form.actividadEconomica,
              required: false,
            },
            estrato: {
              ...this.state.form.estrato,
              required: false,
            },
            tipoUso: {
              ...this.state.form.tipoUso,
              required: false,
            },
            fechaEntradaOperacion: {
              ...this.state.form.fechaEntradaOperacion,
              required: false,
            },
            numeroMedidor: {
              ...this.state.form.numeroMedidor,
              required: true,
            },
          },
        };
      });
    }
  };

  getDocumentosAdjuntos = async (tipoCuentaID) => {
    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/pasos/get-documentos-paso-inicial/${tipoCuentaID}`);
    if (!response.success) {
      AppToast(response.message, false);
    }

    this.setState({
      documentosAdjuntos: response.data,
      pasoID: response.paso_id,
      form: {
        ...this.state.form,
        marcaMedidior: {
          ...this.state.form.marcaMedidior,
          required: tipoCuentaID === 1,
        },
        numeroMedidor: {
          ...this.state.form.numeroMedidor,
          required: tipoCuentaID === 1,
        },
        radicadoProyecto: {
          ...this.state.form.radicadoProyecto,
          required: tipoCuentaID === 2 || tipoCuentaID === 17 || tipoCuentaID === 15,
        },
      },
    });
  };

  getCities = async () => {
    const departamentoID = 41; // Departamento - Huila
    const data = await Api.get(`${Env.UrlBackend}/get-municipios/${departamentoID}`);
    if (!data.success) {
      AppToast(data.message, false);
    }
    this.setState({ municipios: data.data });
    this.setState({ tmpMunicipios: data.data });
  };

  getTipoUso = async () => {
    this.setState({ tipoUso: rsTipoUso });
  };

  getEstratoSocial = async () => {
    this.setState({ estratoSocial: rsEstratoSocial });
  };

  getTipoSolicitud = async () => {
    this.setState({ tipoSolicitud: rsTipoSolicitud });
  };

  getServicioSolicitado = async () => {
    this.setState({ servicioSolicitado: rsServicioSolicitado });
  };

  getMunicipio = async (value) => {
    const data = await Api.get(`${Env.UrlBackend}/get-municipios/${value}`);
    if (!data.success) {
      AppToast(data.message, false);
    }
    this.setState({ municipiosDepartamento: data.data });
  };

  getMunicipioPredio = async (value) => {
    const data = await Api.get(`${Env.UrlBackend}/get-municipios/${value}`);
    if (!data.success) {
      AppToast(data.message, false);
    }
    this.setState({ municipiosPredio: data.data });
  };

  optionTipoUso = async (value) => {
    this.setState({ isVisibleOtroTipoUso: value === 6 });
    const name = this.state.form.estrato.key;

    if (value === 1 || value === 2 || value === 3) {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            [name]: {
              ...statePrev.form[name],
              value: 6,
              disabled: true,
            },
          },
        };
      });
    } else {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            [name]: {
              ...statePrev.form[name],
              disabled: false,
            },
          },
        };
      });
    }

    const nameActividadEconomica = this.state.form.actividadEconomica.key;
    if (value === 0 || value === 4 || value === 5) {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            [nameActividadEconomica]: {
              ...statePrev.form[nameActividadEconomica],
              disabled: true,
              required: false,
            },
          },
        };
      });
    } else {
      this.setState((statePrev) => {
        return {
          form: {
            ...statePrev.form,
            [nameActividadEconomica]: {
              ...statePrev.form[nameActividadEconomica],
              disabled: false,
              required: true,
            },
          },
        };
      });
    }
  };

  optionTipoSolicitud = async (value) => {
    this.setState({ isVisibleExistTipoSolicitud: value !== '0' });
  };

  optionTipoServicio = async (value) => {
    this.setState({ isVisibleOtroServicioSol: value === '8' });
  };

  optionSistemaGeneracion = async (value) => {
    this.setState({ isVisibleLinkGREG: value === 1 });
  };

  selectTipoPersona = async (value) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          tipoPersonaPropietario: {
            ...this.state.form.tipoPersonaPropietario,
            value: parseInt(value) === 31 ? 1 : 0,
            disabled: true,
          },
          razonSocialPropietario: {
            ...this.state.form.razonSocialPropietario,
            value: '',
            disabled: !(parseInt(value) === 31),
          },
          primerNombre: {
            ...this.state.form.primerNombre,
            value: '',
            required: value === 31 ? false : true,
            disabled: value === 31 ? true : false,
          },
          segundoNombre: {
            ...this.state.form.segundoNombre,
            value: '',
            required: false,
            disabled: value === 31 ? true : false,
          },
          primerApellido: {
            ...this.state.form.primerApellido,
            value: '',
            required: value === 31 ? false : true,
            disabled: value === 31 ? true : false,
          },
          segundoApellido: {
            ...this.state.form.segundoApellido,
            value: '',
            required: false,
            disabled: value === 31 ? true : false,
          },
        },
      };
    });
  };

  selectTipoPersonaElectricista = async (value) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          tipoPersonaElectricista: {
            ...this.state.form.tipoPersonaElectricista,
            value: value === '31' ? 1 : 0,
            disabled: true,
          },
          razonSocialElectri: {
            ...this.state.form.razonSocialElectri,
            disabled: value === '31' ? false : true,
            required: false,
          },
          primerNombreElectricista: {
            ...this.state.form.primerNombreElectricista,
            required: value === '31' ? false : true,
            disabled: value === '31' ? true : false,
          },
          segundoNombreElectricista: {
            ...this.state.form.segundoNombreElectricista,
            required: false,
            disabled: value === '31' ? true : false,
          },
          primerApellidoElectricista: {
            ...this.state.form.primerApellidoElectricista,
            required: value === '31' ? false : true,
            disabled: value === '31' ? true : false,
          },
          segundoApellidoElectricista: {
            ...this.state.form.segundoApellidoElectricista,
            required: false,
            disabled: value === '31' ? true : false,
          },
        },
      };
    });
  };

  selectDepartamentoPropietario = async (value) => {
    const result = this.state.loadData.departamento.find((b) => b.codigo === parseInt(value));
    if (!result) {
      return;
    }

    this.setState({
      loadData: {
        ...this.state.loadData,
        municipio: result.municipio,
      },
    });
  };

  selectProyectoEtapa = async (value) => {
    const result = this.state.documentosAdjuntos;
    result.forEach((b) => {
      if (b.id === 91) {
        b.requerido = value.toString();
      }
    });

    this.setState({
      documentosAdjuntos: result,
    });
  };

  selectMarca = async (value) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          marcaMedidior: {
            ...this.state.form.marcaMedidior,
            disabled: value !== 1,
            required: value === 1,
            value: value === 1 ? value : '',
          },
        },
      };
    });
  };

  setDireccion = (name, value) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });

    // switch (name) {
    //   case this.state.form.direccionUbicacion.key:
    //     // this.actualizarDireccionMapa(value, this.state.municipioSelected);
    //     break;
    //   default:
    //     break;
    // }
  };

  validate = () => {
    // Valida los campos obligatorios
    if (!ValidateForm(this.state.form)) {
      return false;
    }

    // Valida que ingrese mínimo un número (propietario)
    if (!ValidateMinTel(this.state.form.telefono.value, this.state.form.celular.value)) {
      return false;
    }

    // Valida que ingrese mínimo un número (electricista)
    if (!ValidateMinTel(this.state.form.telefonoElectricista.value, this.state.form.celularElectricista.value)) {
      return false;
    }

    // Valida formato del email (propietario)
    if (!ValidateEmail(this.state.form.email.value)) {
      AppToast('El email del propietario no tiene un formato válido!', false);
      return false;
    }

    // Valida formato del email (electricista)
    if (!ValidateEmail(this.state.form.emailElectricista.value)) {
      AppToast('El email del electricista no tiene un formato válido!', false);
      return false;
    }

    //SOLO VALIDAR CUANDO SE HACE EL REGISTRO
    if (!this.state.form.isUpdateCuentaNueva.value) {
      if (this.state.tipoUsuario === Env.tipoUsuario.electricista) {
        if (!this.state.fileAutorizacionPropietario) {
          AppToast('Debe adjuntar el documento de autorización del propietario.', false);
          return false;
        }
      }

      if (!this.state.existeElectricista) {
        if (!this.state.fileCedulaElectricista) {
          AppToast('Debe adjuntar el documento de identidad del electricista.', false);
          return false;
        }

        if (!this.state.fileTarjetaProfesionalElectricista) {
          AppToast('Debe adjuntar el certificado de la tarjeta profesional del electricista.', false);
          return false;
        }

        if (!this.state.fileTarjetaProfesionalElectricista) {
          AppToast('Debe adjuntar el certificado de la tarjeta profesional del electricista.', false);
          return false;
        }
      }

      // --- Valido que adjunte toda la documentacion obligatoria
      for (let value of this.state.documentosAdjuntos) {
        /*if (value.requerido === '1') {
          if (!value.archivo) {
            AppToast(`Debe adjuntar el archivo: ${value.nombre}`, false);
            return false;
          }
        }*/ //QUITAR COMENTARIOS
      }
    }

    // if (this.state.latlng.lat === null || this.state.latlng.lng === null) {
    //     AppToast('Debe marcar la ubicación en el mapa', false);
    //     return false;
    // }

    return true;
  };

  getFormData = (params) => {
    let formData = new FormData();
    for (const name in params) {
      formData.append(name, params[name] === undefined ? null : params[name]);
    }
    return formData;
  };

  openDialogDireccion = (name) => {
    this.setState({
      openDialog: true,
      currentKey: name,
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validate()) {
      return;
    }

    const user = Session.getLogin();
    let params = GetDataApi(this.state.form);
    params = {
      ...params,
      documento_usuario_creacion: user.terceroDocumento,
      paso_id: this.state.pasoID,
      lat: this.state.latlng.lat,
      lng: this.state.latlng.lng,
      fileAutorizacionPropietario: this.state.fileAutorizacionPropietario,
      fileCedulaElectricista: this.state.fileCedulaElectricista,
      fileTarjetaProfesionalElectricista: this.state.fileTarjetaProfesionalElectricista,
      fileActaDiplomaGrado: this.state.fileActaDiplomaGrado,
      documentosAdjuntos: JSON.stringify(this.state.documentosAdjuntos),
      tipoUsuario: this.state.tipoUsuario,
    };

    // Asigno la documentacion requerida a los parametros
    for (let value of this.state.documentosAdjuntos) {
      if (value.archivo) {
        params = {
          ...params,
          [`documentacion_${value.id}`]: value.archivo,
        };
      }
    }

    const formData = this.getFormData(params);

    const data = this.state.form.isUpdateCuentaNueva.value
      ? await Api.postWithoutFormData(`${Env.UrlBackendCuentaNueva}/solicitud/updated`, formData)
      : await Api.postWithoutFormData(`${Env.UrlBackendCuentaNueva}/solicitud/create`, formData);

    if (data.success) {
      AppToast(data.message, true);
      this.setState({
        url: '/new-account-list',
      });
    } else {
      AppToast(data.message, false);
    }
  };

  onSetRegistrocuentatipo = async (e) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          registrocuentatipo: {
            ...statePrev.form['registrocuentatipo'],
            value: e,
          },
        },
      };
    });
  };

  render() {
    return (
      <div style={{ minHeight: '500px', textAlign: 'center' }}>
        <Redirect url={this.state.url} />

        <AppBreadcrumbs
          links={[
            {
              url: 'accounts',
              label: 'Cuentas',
            },
            {
              url: 'new-account-list',
              label: 'Listado de cuentas nuevas',
            },
          ]}
          actual="Radicar Cuenta Nueva"
        />

        <h2>
          <span>
            {this.state.form.isUpdateCuentaNueva.value ? 'Actaulizar' : 'Radicar'} Cuentas Nuevas. /
            {this.state.tipoUsuario === Env.tipoUsuario.electricista ? (
              <span>
                {' '}
                Electricista <Icon color="secondary">engineering</Icon>
              </span>
            ) : (
              <span>
                Propietario <AccessibilityIcon color="primary" />{' '}
              </span>
            )}
          </span>
        </h2>

        <Card style={{ padding: '20px', width: '80%', margin: 'auto' }}>
          <OwnerEngineerValidator useModal={true} docProp={this.state.form.numeroDocumento.value} docEng={this.state.form.numeroDocumentoElectricista.value}>
            <form onSubmit={this.handleSubmit}>
              <Grid container direction="column" justify="flex-start" alignItems="center">
                <Grid container justify="center">
                  <Grid item xs={12} sm={5}>
                    <FormControl required variant="outlined" style={{ width: '100%' }}>
                      <InputLabel id="demo-simple-select-outlined-label">Tipo de cuenta</InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id={this.state.form.tipoCuentaNueva.key}
                        name={this.state.form.tipoCuentaNueva.key}
                        value={this.state.form.tipoCuentaNueva.value}
                        onChange={this.handleChange}
                        label="Tipo de cuenta"
                        required={this.state.form.tipoCuentaNueva.required}
                        variant="outlined"
                        disabled={this.state.form.tipoCuentaNueva.disabled}
                      >
                        {this.state.loadData.tipos.map((val, index) => {
                          return (
                            <MenuItem key={index} value={val.id}>
                              {val.nombre}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <fieldset style={{ width: '97.5%' }}>
                  <legend style={{ textAlign: 'left' }}>Información del propietario</legend>

                  {this.state.tipoUsuario === Env.tipoUsuario.electricista ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoDocumento.key}
                            name={this.state.form.tipoDocumento.key}
                            value={this.state.form.tipoDocumento.value}
                            disabled={this.state.form.tipoDocumento.disabled}
                            onChange={this.handleChange}
                            label="Tipo Documento"
                            required={this.state.form.tipoDocumento.required}
                            variant="outlined"
                          >
                            {this.state.loadData.documentTypes.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.documentoTipoID}>
                                  {val.documentoTipoDescripcion}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de Persona</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoPersonaPropietario.key}
                            name={this.state.form.tipoPersonaPropietario.key}
                            value={this.state.form.tipoPersonaPropietario.value}
                            disabled="true"
                            onChange={this.handleChange}
                            label="Tipo de persona"
                            required={this.state.form.tipoPersonaPropietario.required}
                            variant="outlined"
                          >
                            {[
                              { value: 0, label: 'Persona Natural' },
                              { value: 1, label: 'Persona Juridica' },
                            ].map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.label}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <AppInputNumber
                          id={this.state.form.numeroDocumento.key}
                          name={this.state.form.numeroDocumento.key}
                          value={this.state.form.numeroDocumento.value}
                          disabled={this.state.form.numeroDocumento.disabled}
                          label="Número de documento"
                          onChange={this.handleChange}
                          onKeyDown={this.keyPress}
                          onBlur={(e) => {
                            this.keyPress(e, 'onBlur');
                          }}
                          required={this.state.form.numeroDocumento.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <AppInputText
                          id={this.state.form.razonSocialPropietario.key}
                          name={this.state.form.razonSocialPropietario.key}
                          value={this.state.form.razonSocialPropietario.value}
                          onChange={this.handleChange}
                          disabled={this.state.form.razonSocialPropietario.disabled}
                          required={this.state.form.razonSocialPropietario.required}
                          label="Razón Social"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.primerNombre.key}
                          name={this.state.form.primerNombre.key}
                          value={this.state.form.primerNombre.value}
                          disabled={this.state.form.primerNombre.disabled}
                          label="Primer Nombre"
                          onChange={this.handleChange}
                          required={this.state.form.primerNombre.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.segundoNombre.key}
                          name={this.state.form.segundoNombre.key}
                          value={this.state.form.segundoNombre.value}
                          disabled={this.state.form.segundoNombre.disabled}
                          label="Segundo Nombre"
                          onChange={this.handleChange}
                          required={this.state.form.segundoNombre.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.primerApellido.key}
                          name={this.state.form.primerApellido.key}
                          value={this.state.form.primerApellido.value}
                          disabled={this.state.form.primerApellido.disabled}
                          label="Primer Apellido"
                          onChange={this.handleChange}
                          required={this.state.form.primerApellido.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.segundoApellido.key}
                          name={this.state.form.segundoApellido.key}
                          value={this.state.form.segundoApellido.value}
                          disabled={this.state.form.segundoApellido.disabled}
                          label="Segundo Apellido"
                          onChange={this.handleChange}
                          required={this.state.form.segundoApellido.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.email.key}
                          name={this.state.form.email.key}
                          value={this.state.form.email.value}
                          disabled={this.state.form.email.disabled}
                          label="Email"
                          onChange={this.handleChange}
                          required={this.state.form.email.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputTel
                          id={this.state.form.telefono.key}
                          name={this.state.form.telefono.key}
                          value={this.state.form.telefono.value}
                          disabled={this.state.form.telefono.disabled}
                          label="Teléfono"
                          onChange={this.handleChange}
                          required={this.state.form.telefono.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputCel
                          id={this.state.form.celular.key}
                          name={this.state.form.celular.key}
                          value={this.state.form.celular.value}
                          disabled={this.state.form.celular.disabled}
                          label="Celular"
                          onChange={this.handleChange}
                          required={this.state.form.celular.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <AppInputText
                          id={this.state.form.direccion.key}
                          name={this.state.form.direccion.key}
                          value={this.state.form.direccion.value}
                          disabled={this.state.form.direccion.disabled}
                          label="Propietario Dirección"
                          onChange={this.handleChange}
                          readonly={true}
                          onclick={() => {
                            this.openDialogDireccion(this.state.form.direccion.key);
                          }}
                          required={this.state.form.direccion.required}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.departamentoPropietario.key}
                            name={this.state.form.departamentoPropietario.key}
                            value={this.state.form.departamentoPropietario.value}
                            onChange={this.handleChange}
                            disabled={this.state.form.departamentoPropietario.disabled}
                            label="Departamento"
                            required={this.state.form.departamentoPropietario.required}
                            variant="outlined"
                          >
                            {this.state.loadData.departamento.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.codigo}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.municipioPropietario.key}
                            name={this.state.form.municipioPropietario.key}
                            value={this.state.form.municipioPropietario.value}
                            disabled={this.state.form.municipioPropietario.disabled}
                            onChange={this.handleChange}
                            label="Tipo de cuenta"
                            required={this.state.form.municipioPropietario.required}
                            variant="outlined"
                          >
                            {this.state.loadData.municipio.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.codigo}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <AppCheckbox
                          id={this.state.form.autorizaNotificacionPropietario.key}
                          name={this.state.form.autorizaNotificacionPropietario.key}
                          value={this.state.form.autorizaNotificacionPropietario.value}
                          label="¿Autoriza la notificación mediante correo electrónico?"
                          onChange={this.handleChangeCheck}
                          required={this.state.form.autorizaNotificacionPropietario.required}
                        ></AppCheckbox>
                        {this.state.form.autorizaNotificacionPropietario.value ? '' : <label style={{ color: 'red' }}>*</label>}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <AppCheckbox
                          id={this.state.form.propietarioPropietario.key}
                          name={this.state.form.propietarioPropietario.key}
                          value={this.state.form.propietarioPropietario.value}
                          label="¿El solicitante es el propietario del predio?"
                          onChange={this.handleChangeCheck}
                        ></AppCheckbox>
                        {this.state.form.propietarioPropietario.value ? '' : <label style={{ color: 'red' }}>*</label>}
                      </Grid>

                      {this.state.form.isUpdateCuentaNueva.value ? null : (
                        <Grid item xs={12} sm={12}>
                          <div
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              marginBottom: '10px',
                            }}
                          >
                            <label>
                              Adjunte la autorización del propietario. Debe estar firmado de manera manuscrita; no se aceptan firmas recortadas o digitalizadas.
                              <span className="file-obligatorio"> * </span>
                            </label>
                            <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileAutorizacionPropietario')} />
                          </div>

                          <Alert severity="info" style={{ textAlign: 'left' }}>
                            * El tamaño máximo permitido es de {Env.AllowedSize} megas.
                            <br />
                            * El documento debe ser de extensión .pdf
                            <br />* Adjuntar autorización del propietario debidamente autenticado, de no cumplir lo anunciado anteriormente se rechazará la
                            solicitud.
                          </Alert>
                        </Grid>
                      )}
                    </Grid>
                  ) : (
                    <InformacionPropietario />
                  )}
                </fieldset>

                {/*INFORMACION ELECTRICISTA*/}
                <fieldset>
                  <legend style={{ textAlign: 'left' }}>Información del electricista</legend>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <FormControl required variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id={this.state.form.tipoDocumentoElectricista.key}
                          name={this.state.form.tipoDocumentoElectricista.key}
                          value={this.state.form.tipoDocumentoElectricista.value}
                          disabled={this.state.form.tipoDocumentoElectricista.disabled}
                          onChange={this.handleChange}
                          label="Tipo Documento"
                          required={this.state.form.tipoDocumentoElectricista.required}
                          variant="outlined"
                        >
                          {this.state.loadData.documentTypes.map((val, index) => {
                            return (
                              <MenuItem key={index} value={val.documentoTipoID}>
                                {val.documentoTipoDescripcion}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl required variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Tipo de Persona</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id={this.state.form.tipoPersonaElectricista.key}
                          name={this.state.form.tipoPersonaElectricista.key}
                          value={this.state.form.tipoPersonaElectricista.value}
                          disabled="true"
                          onChange={this.handleChange}
                          label="Tipo de persona"
                          required={this.state.form.tipoPersonaElectricista.required}
                          variant="outlined"
                        >
                          {[
                            { value: 0, label: 'Persona Natural' },
                            { value: 1, label: 'Persona Juridica' },
                          ].map((val, index) => {
                            return (
                              <MenuItem key={index} value={val.value}>
                                {val.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <AppInputNumber
                        id={this.state.form.numeroDocumentoElectricista.key}
                        name={this.state.form.numeroDocumentoElectricista.key}
                        value={this.state.form.numeroDocumentoElectricista.value}
                        disabled={this.state.form.numeroDocumentoElectricista.disabled}
                        placeholder="Buscar por número de documento"
                        label="Número de documento"
                        icon={<SearchIcon />}
                        onChange={this.handleChange}
                        onKeyDown={this.keyPress}
                        onBlur={(e) => {
                          this.keyPress(e, 'onBlur');
                        }}
                        required={this.state.form.numeroDocumentoElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <AppInputText
                        id={this.state.form.numeroTarjetaProfesionalElectricista.key}
                        name={this.state.form.numeroTarjetaProfesionalElectricista.key}
                        value={this.state.form.numeroTarjetaProfesionalElectricista.value}
                        disabled={this.state.form.numeroTarjetaProfesionalElectricista.disabled}
                        placeholder="Buscar por matrícula"
                        label="Nro. Matrícula Profesional"
                        icon={<SearchIcon />}
                        onChange={this.handleChange}
                        onKeyDown={this.keyPress}
                        onBlur={(e) => {
                          this.keyPress(e, 'onBlur');
                        }}
                        required={this.state.form.numeroTarjetaProfesionalElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <AppInputText
                        id={this.state.form.razonSocialElectri.key}
                        name={this.state.form.razonSocialElectri.key}
                        value={this.state.form.razonSocialElectri.value}
                        onChange={this.handleChange}
                        disabled={this.state.form.razonSocialElectri.disabled}
                        label="Razón Social"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.primerNombreElectricista.key}
                        name={this.state.form.primerNombreElectricista.key}
                        value={this.state.form.primerNombreElectricista.value}
                        disabled={this.state.form.primerNombreElectricista.disabled}
                        label="Primer Nombre"
                        onChange={this.handleChange}
                        required={this.state.form.primerNombreElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.segundoNombreElectricista.key}
                        name={this.state.form.segundoNombreElectricista.key}
                        value={this.state.form.segundoNombreElectricista.value}
                        disabled={this.state.form.segundoNombreElectricista.disabled}
                        label="Segundo Nombre"
                        onChange={this.handleChange}
                        required={this.state.form.segundoNombreElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.primerApellidoElectricista.key}
                        name={this.state.form.primerApellidoElectricista.key}
                        value={this.state.form.primerApellidoElectricista.value}
                        disabled={this.state.form.primerApellidoElectricista.disabled}
                        label="Primer Apellido"
                        onChange={this.handleChange}
                        required={this.state.form.primerApellidoElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.segundoApellidoElectricista.key}
                        name={this.state.form.segundoApellidoElectricista.key}
                        value={this.state.form.segundoApellidoElectricista.value}
                        disabled={this.state.form.segundoApellidoElectricista.disabled}
                        label="Segundo Apellido"
                        onChange={this.handleChange}
                        required={this.state.form.segundoApellidoElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.emailElectricista.key}
                        name={this.state.form.emailElectricista.key}
                        value={this.state.form.emailElectricista.value}
                        disabled={this.state.form.emailElectricista.disabled}
                        label="Email"
                        onChange={this.handleChange}
                        required={this.state.form.emailElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputTel
                        id={this.state.form.telefonoElectricista.key}
                        name={this.state.form.telefonoElectricista.key}
                        value={this.state.form.telefonoElectricista.value}
                        disabled={this.state.form.telefonoElectricista.disabled}
                        label="Teléfono"
                        onChange={this.handleChange}
                        required={this.state.form.telefonoElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputCel
                        id={this.state.form.celularElectricista.key}
                        name={this.state.form.celularElectricista.key}
                        value={this.state.form.celularElectricista.value}
                        disabled={this.state.form.celularElectricista.disabled}
                        label="Celular"
                        onChange={this.handleChange}
                        required={this.state.form.celularElectricista.required}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.direccionElectricista.key}
                        name={this.state.form.direccionElectricista.key}
                        value={this.state.form.direccionElectricista.value}
                        disabled={this.state.form.direccionElectricista.disabled}
                        label="Dirección de correspondencia"
                        onChange={this.handleChange}
                        readonly={true}
                        onclick={() => {
                          this.openDialogDireccion(this.state.form.direccionElectricista.key);
                        }}
                        required={this.state.form.direccionElectricista.required}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl required variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id={this.state.form.departamentoElectricista.key}
                          name={this.state.form.departamentoElectricista.key}
                          value={this.state.form.departamentoElectricista.value}
                          onChange={this.handleChange}
                          disabled={this.state.form.departamentoElectricista.disabled}
                          label="Departamento"
                          required={this.state.form.departamentoElectricista.required}
                          variant="outlined"
                        >
                          {rsDepartamento.map((val, index) => {
                            return (
                              <MenuItem key={index} value={val.value}>
                                {val.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl required variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id={this.state.form.municipioElectricista.key}
                          name={this.state.form.municipioElectricista.key}
                          value={this.state.form.municipioElectricista.value}
                          disabled={this.state.form.municipioElectricista.disabled}
                          onChange={this.handleChange}
                          label="Tipo de cuenta"
                          required={this.state.form.municipioElectricista.required}
                          variant="outlined"
                        >
                          {this.state.municipiosDepartamento.map((val, index) => {
                            return (
                              <MenuItem key={index} value={val.codigo}>
                                {val.nombre}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    {!this.state.form.isUpdateCuentaNueva.value && !this.state.existeElectricista ? (
                      <>
                        <Grid item xs={12} sm={6}>
                          <div
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              marginBottom: '10px',
                            }}
                          >
                            <label>
                              Adjunte el documento de identidad <span className="file-obligatorio"> * </span>{' '}
                            </label>
                            <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileCedulaElectricista')} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <div
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              marginBottom: '10px',
                            }}
                          >
                            <label>
                              Adjunte la tarjeta profesional <span className="file-obligatorio"> * </span>{' '}
                            </label>
                            <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileTarjetaProfesionalElectricista')} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <div
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              marginBottom: '10px',
                            }}
                          >
                            <label>
                              Adjunte el acta/diploma de grado <span className="file-obligatorio"> * </span>{' '}
                            </label>
                            <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileActaDiplomaGrado')} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Alert severity="info" style={{ textAlign: 'left' }}>
                            * El tamaño máximo permitido es de {Env.AllowedSize} mega por cada documento
                            <br />* Los documentos deben ser de extensión .pdf
                          </Alert>
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                </fieldset>

                {this.state.form.isUpdateCuentaNueva.value ? null : this.state.documentosAdjuntos.length > 0 ? (
                  <fieldset style={{ marginTop: '20px' }}>
                    <legend style={{ textAlign: 'left' }}>Adjuntar documentación</legend>

                    <div style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                      <span>
                        ¡Puede descargar los formatos dando clic en el siguiente
                        <a target="_blank" rel="noopener noreferrer" href="https://www.electrohuila.com.co/tramites-usuarios/">
                          {' '}
                          enlace
                        </a>
                        !
                      </span>
                    </div>
                    <Grid container spacing={2}>
                      {this.state.documentosAdjuntos.map((val, index) => {
                        return (
                          <Grid item xs={12} sm={6} key={index}>
                            <div
                              style={{
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                marginBottom: '10px',
                              }}
                            >
                              <label style={{ fontSize: '11px' }}>
                                {val.nombre}
                                <span className="file-obligatorio">{val.requerido === '1' ? ' * ' : ''}</span>
                              </label>
                              <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFilesDinamic(e, val, 0)} />

                              <Alert severity="info" style={{ textAlign: 'left' }}>
                                {val.link_formato ? (
                                  <span>
                                    * Descargar Formato &nbsp;
                                    <a rel="noopener noreferrer" href={val.link_formato} target="_blank">
                                      aquí
                                    </a>
                                  </span>
                                ) : null}
                                {val.descripcion_formato ? <span>* {val.descripcion_formato}</span> : null}* El tamaño máximo permitido es de {val.tamanio}{' '}
                                megas
                                <br />* Extensiones permitidas: {val.tipos}
                              </Alert>
                            </div>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </fieldset>
                ) : null}

                <fieldset style={{ width: '97.5%', marginTop: '20px' }}>
                  <legend style={{ textAlign: 'left' }}>Información de la solicitud</legend>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}>
                      <AppInputNumber
                        id={this.state.form.codigoProyecto.key}
                        name={this.state.form.codigoProyecto.key}
                        value={this.state.form.codigoProyecto.value}
                        label="Código del proyecto"
                        onChange={this.handleChange}
                        required={this.state.form.codigoProyecto.required}
                        disabled={this.state.form.codigoProyecto.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <AppInputNumber
                        id={this.state.form.radicadoProyecto.key}
                        name={this.state.form.radicadoProyecto.key}
                        value={this.state.form.radicadoProyecto.value}
                        label="Radicado del proyecto general"
                        onChange={this.handleChange}
                        required={this.state.form.radicadoProyecto.required}
                        disabled={this.state.form.radicadoProyecto.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputText
                        id={this.state.form.nombreProyecto.key}
                        name={this.state.form.nombreProyecto.key}
                        value={this.state.form.nombreProyecto.value}
                        label="Nombre del proyecto"
                        onChange={this.handleChange}
                        required={this.state.form.nombreProyecto.required}
                        disabled={this.state.form.nombreProyecto.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl required variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Nivel de Tensión</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id={this.state.form.nivelTension.key}
                          name={this.state.form.nivelTension.key}
                          value={this.state.form.nivelTension.value}
                          onChange={this.handleChange}
                          label="Nivel de Tensión"
                          required={this.state.form.nivelTension.required}
                          variant="outlined"
                        >
                          {this.state.loadData.nivelesTension.map((val, index) => {
                            return (
                              <MenuItem key={index} value={val.id}>
                                {val.nombre} - {val.descripcion}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputNumber
                        id={this.state.form.kva.key}
                        name={this.state.form.kva.key}
                        value={this.state.form.kva.value}
                        label="KVA"
                        onChange={this.handleChange}
                        required={this.state.form.kva.required}
                        disabled={this.state.form.kva.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <AppInputNumber
                        id={this.state.form.kv.key}
                        name={this.state.form.kv.key}
                        value={this.state.form.kv.value}
                        label="KV"
                        onChange={this.handleChange}
                        required={this.state.form.kv.required}
                        disabled={this.state.form.kv.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <AppInputText
                        id={this.state.form.direccionUbicacion.key}
                        name={this.state.form.direccionUbicacion.key}
                        value={this.state.form.direccionUbicacion.value}
                        label="Proyecto Dirección"
                        onChange={this.handleChange}
                        readonly={true}
                        onclick={() => {
                          this.openDialogDireccion(this.state.form.direccionUbicacion.key);
                        }}
                        required={this.state.form.direccionUbicacion.required}
                        disabled={this.state.form.direccionUbicacion.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <AppInputText
                        id={this.state.form.nodoConexion.key}
                        name={this.state.form.nodoConexion.key}
                        value={this.state.form.nodoConexion.value}
                        label="Nodo Conexión"
                        onChange={this.handleChange}
                        required={this.state.form.nodoConexion.required}
                        disabled={this.state.form.nodoConexion.disabled}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <AppInputText
                        id={this.state.form.codigoTransformador.key}
                        name={this.state.form.codigoTransformador.key}
                        value={this.state.form.codigoTransformador.value}
                        label="Código Transformador"
                        onChange={this.handleChange}
                        required={this.state.form.codigoTransformador.required}
                        disabled={this.state.form.codigoTransformador.disabled}
                      />
                    </Grid>

                    {this.state.form.tipoCuentaNueva.value === 17 ? (
                      <>
                        <Grid item xs={12} sm={4}>
                          <FormControl required variant="outlined" style={{ width: '100%' }}>
                            <InputLabel id="demo-simple-select-outlined-label">Zona</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id={this.state.form.zona.key}
                              name={this.state.form.zona.key}
                              value={this.state.form.zona.value}
                              onChange={this.handleChange}
                              label="Zona"
                              required={this.state.form.zona.required}
                              disabled={this.state.form.zona.disabled}
                              variant="outlined"
                            >
                              {this.state.loadData.zonas.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val.id}>
                                    {val.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <FormControl required variant="outlined" style={{ width: '100%' }}>
                            <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id={this.state.form.departamentoUbicacion.key}
                              name={this.state.form.departamentoUbicacion.key}
                              value={this.state.form.departamentoUbicacion.value}
                              onChange={this.handleChange}
                              label="Departamento"
                              required={true}
                              disabled={this.state.form.departamentoUbicacion.disabled}
                              variant="outlined"
                            >
                              {this.state.departamento.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val.value}>
                                    {val.label}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <FormControl required variant="outlined" style={{ width: '100%' }}>
                            <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id={this.state.form.municipioUbicacion.key}
                              name={this.state.form.municipioUbicacion.key}
                              value={this.state.form.municipioUbicacion.value}
                              onChange={this.handleChange}
                              label="Municipio"
                              required={true}
                              variant="outlined"
                              disabled={this.state.form.municipioUbicacion.disabled}
                            >
                              {this.state.municipiosPredio.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val.codigo}>
                                    {val.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <AppInputNumber
                            id={this.state.form.numeroMedidor.key}
                            name={this.state.form.numeroMedidor.key}
                            value={this.state.form.numeroMedidor.value}
                            label="Número Medidor"
                            onChange={this.handleChange}
                            required={this.state.form.numeroMedidor.required}
                            disabled={this.state.form.numeroMedidor.disabled}
                          />
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                </fieldset>

                {this.state.seccions.siteInformation.value ? (
                  <fieldset style={{ width: '97.5%' }}>
                    <legend style={{ textAlign: 'left' }}>Datos del Predio</legend>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Población</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoZona.key}
                            name={this.state.form.tipoZona.key}
                            value={this.state.form.tipoZona.value}
                            onChange={this.handleChange}
                            label="Tipo zona"
                            required={true}
                            variant="outlined"
                            disabled={this.state.form.tipoZona.disabled}
                          >
                            {location.tipoZona.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.detalle}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Zona</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.zona.key}
                            name={this.state.form.zona.key}
                            value={this.state.form.zona.value}
                            onChange={this.handleChange}
                            label="Zona"
                            required={this.state.form.zona.required}
                            disabled={this.state.form.zona.disabled}
                            variant="outlined"
                          >
                            {this.state.loadData.zonas.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.id}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.niu.key}
                          name={this.state.form.niu.key}
                          value={this.state.form.niu.value}
                          disabled={this.state.form.niu.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.niu.required}
                          label="Número de cuenta - NIU"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.comuna.key}
                          name={this.state.form.comuna.key}
                          value={this.state.form.comuna.value}
                          disabled={this.state.form.comuna.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.comuna.required}
                          label="Comuna"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>

                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.departamentoUbicacion.key}
                            name={this.state.form.departamentoUbicacion.key}
                            value={this.state.form.departamentoUbicacion.value}
                            onChange={this.handleChange}
                            label="Departamento"
                            required={true}
                            disabled={this.state.form.departamentoUbicacion.disabled}
                            variant="outlined"
                          >
                            {this.state.loadData.departamento_predio.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.codigo}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.municipioUbicacion.key}
                            name={this.state.form.municipioUbicacion.key}
                            value={this.state.form.municipioUbicacion.value}
                            onChange={this.handleChange}
                            label="Municipio"
                            required={true}
                            variant="outlined"
                            disabled={this.state.form.municipioUbicacion.disabled}
                          >
                            {this.state.municipiosPredio.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.codigo}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.direccionPredio.key}
                          name={this.state.form.direccionPredio.key}
                          value={this.state.form.direccionUbicacion.value}
                          onChange={this.handleChange}
                          required={this.state.form.direccionPredio.required}
                          label="Dirección del predio"
                          disabled="true"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.geoPredio.key}
                          name={this.state.form.geoPredio.key}
                          value={this.state.form.geoPredio.value}
                          disabled={this.state.form.geoPredio.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.geoPredio.required}
                          label="Ubicación georreferenciada"
                          placeholder="Latitude is : 0 , Longitude is : 0"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.matriculaPredio.key}
                          name={this.state.form.matriculaPredio.key}
                          value={this.state.form.matriculaPredio.value}
                          disabled={this.state.form.matriculaPredio.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.matriculaPredio.required}
                          label="Matrícula Inmobiliaria"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">¿Edificación existente o proyecto?</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.isEdificacionExistente.key}
                            name={this.state.form.isEdificacionExistente.key}
                            value={this.state.form.isEdificacionExistente.value}
                            onChange={this.handleChange}
                            label="¿Edificación existente o proyecto?"
                            required={true}
                            variant="outlined"
                            disabled={this.state.form.isEdificacionExistente.disabled}
                          >
                            {[
                              { value: '0', detalle: 'Si' },
                              { value: '1', detalle: 'No' },
                            ].map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.detalle}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <AppInputText
                          id={this.state.form.indicacionPredio.key}
                          name={this.state.form.indicacionPredio.key}
                          value={this.state.form.indicacionPredio.value}
                          disabled={this.state.form.indicacionPredio.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.indicacionPredio.required}
                          label="Indicaciones de acceso al predio"
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                ) : null}

                {this.state.seccions.typesUse.value ? (
                  <fieldset style={{ width: '97.5%' }}>
                    <legend style={{ textAlign: 'left' }}>Tipos de uso y actividad económica</legend>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de Uso</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoUso.key}
                            name={this.state.form.tipoUso.key}
                            value={this.state.form.tipoUso.value}
                            disabled={this.state.form.tipoUso.disabled}
                            onChange={this.handleChange}
                            label="Tipo de Uso"
                            required={true}
                            variant="outlined"
                          >
                            {this.state.loadData.tipoUso.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.tipo_uso_id}>
                                  {val.tipo_uso_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      {this.state.isVisibleOtroTipoUso ? (
                        <Grid item xs={12} sm={4}>
                          <AppInputText
                            id={this.state.form.otroTipoUso.key}
                            name={this.state.form.otroTipoUso.key}
                            value={this.state.form.otroTipoUso.value}
                            disabled={this.state.form.otroTipoUso.disabled}
                            onChange={this.handleChange}
                            required={this.state.form.otroTipoUso.required}
                            label="¿Cuál?"
                          />
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Estrato socioeconómico</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.estrato.key}
                            name={this.state.form.estrato.key}
                            value={this.state.form.estrato.value}
                            disabled={this.state.form.estrato.disabled}
                            onChange={this.handleChange}
                            label="Estrato socioeconómico"
                            required={true}
                            variant="outlined"
                          >
                            {this.state.loadData.estratoSocial.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.estrato_social_id}>
                                  {val.estrato_social_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Autocomplete
                          options={economicActivity.sort((a, b) => -b.name.localeCompare(a.name))}
                          getOptionLabel={(option) => option.code + ' - ' + option.name}
                          sx={{ width: 300 }}
                          onChange={this.handleActividadEconomicaChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              id={this.state.form.actividadEconomica.key}
                              name={this.state.form.actividadEconomica.key}
                              value={this.state.form.actividadEconomica.value}
                              disabled={this.state.form.actividadEconomica.disabled}
                              onChange={this.handleChange}
                              //required={this.state.form.actividadEconomica.required}
                              label="Actividad económica CIIU *"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                ) : null}

                {this.state.seccions.infrastructureData.value ? (
                  <fieldset style={{ width: '97.5%' }}>
                    <legend style={{ textAlign: 'left' }}>Datos de infraestructura eléctrica actual conexiones sencillas</legend>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">¿Hay red eléctrica cercana al predio?</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.redCercana.key}
                            name={this.state.form.redCercana.key}
                            value={this.state.form.redCercana.value}
                            onChange={this.handleChange}
                            label="Tipo de Uso"
                            disabled={this.state.form.redCercana.disabled}
                            variant="outlined"
                          >
                            {[
                              { value: '0', detalle: 'Si' },
                              { value: '1', detalle: 'No' },
                            ].map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.detalle}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.cuentaVecina.key}
                          name={this.state.form.cuentaVecina.key}
                          value={this.state.form.cuentaVecina.value}
                          disabled={this.state.form.cuentaVecina.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.cuentaVecina.required}
                          label="Cuenta vecina"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.distanciaRed.key}
                          name={this.state.form.distanciaRed.key}
                          value={this.state.form.distanciaRed.value}
                          disabled={this.state.form.distanciaRed.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.distanciaRed.required}
                          label="Distancia actual del predio a la red más cercana"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.transfoCercano.key}
                          name={this.state.form.transfoCercano.key}
                          value={this.state.form.codigoTransformador.value}
                          disabled="true"
                          onChange={this.handleChange}
                          required={this.state.form.transfoCercano.required}
                          label="# Transformador cercano"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.nodeCercano.key}
                          name={this.state.form.nodeCercano.key}
                          value={this.state.form.nodoConexion.value}
                          disabled="true"
                          onChange={this.handleChange}
                          required={this.state.form.nodeCercano.required}
                          label="# Node de conexión (M/B)"
                        />
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <strong>Los datos registrados de la infraestructura eléctrica se validarán en el terreno.</strong>
                      </Grid>
                    </Grid>
                  </fieldset>
                ) : null}

                {this.state.seccions.serviceDetail.value ? (
                  <fieldset style={{ width: '97.5%' }}>
                    <legend style={{ textAlign: 'left' }}>Detalle del Servicio</legend>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.nombreProyecto.key}
                          name={this.state.form.nombreProyecto.key}
                          value={this.state.form.nombreProyecto.value}
                          label="Nombre del proyecto"
                          onChange={this.handleChange}
                          required={this.state.form.nombreProyecto.required}
                          disabled="true"
                        />
                      </Grid>

                      {this.state.form.tipoCuentaNueva.value === 3 ? (
                        <Grid item xs={12} sm={4}>
                          <FormControl required variant="outlined" style={{ width: '100%' }}>
                            <InputLabel id="demo-simple-select-outlined-label">¿Proyecto se realizará por etapas?</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id={this.state.form.proyectoEtapa.key}
                              name={this.state.form.proyectoEtapa.key}
                              value={this.state.form.proyectoEtapa.value}
                              disabled={this.state.form.proyectoEtapa.disabled}
                              onChange={this.handleChange}
                              variant="outlined"
                            >
                              {[
                                { value: 1, detalle: 'Si' },
                                {
                                  value: 0,
                                  detalle: 'No',
                                },
                              ].map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val.value}>
                                    {val.detalle}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de solicitud</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoSolicitud.key}
                            name={this.state.form.tipoSolicitud.key}
                            value={this.state.form.tipoSolicitud.value}
                            disabled={this.state.form.tipoSolicitud.disabled}
                            onChange={this.handleChange}
                            variant="outlined"
                          >
                            {this.state.loadData.tipoSolicitud.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.tipo_solicitud_id}>
                                  {val.tipo_solicitud_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      {this.state.isVisibleExistTipoSolicitud ? (
                        <Grid item xs={12} sm={4}>
                          <AppInputText
                            id={this.state.form.numSolicitud.key}
                            name={this.state.form.numSolicitud.key}
                            value={this.state.form.numSolicitud.value}
                            disabled={this.state.form.numSolicitud.disabled}
                            onChange={this.handleChange}
                            required={this.state.form.numSolicitud.required}
                            label="No. Solicitud"
                          />
                        </Grid>
                      ) : null}
                      {this.state.isVisibleExistTipoSolicitud ? (
                        <Grid item xs={12} sm={4}>
                          <AppInputDate
                            id={this.state.form.vigenciaSolicitud.key}
                            name={this.state.form.vigenciaSolicitud.key}
                            value={this.state.form.vigenciaSolicitud.value}
                            disabled={this.state.form.vigenciaSolicitud.disabled}
                            onChange={this.handleChange}
                            required={this.state.form.vigenciaSolicitud.required}
                            title="Diligenciar en caso de modificación o revalidación de una solicitud existente."
                            label="Vigencia"
                          />
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de servicio solicitado</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.tipoServicio.key}
                            name={this.state.form.tipoServicio.key}
                            value={this.state.form.tipoServicio.value}
                            disabled={this.state.form.tipoServicio.disabled}
                            onChange={this.handleChange}
                            // required={true}
                            variant="outlined"
                          >
                            {this.state.loadData.servicioSolicitado.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.tipo_servicio_id}>
                                  {val.tipo_servicio_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      {this.state.isVisibleOtroServicioSol ? (
                        <Grid item xs={12} sm={4}>
                          <AppInputText
                            id={this.state.form.tipoServicioOtro.key}
                            name={this.state.form.tipoServicioOtro.key}
                            value={this.state.form.tipoServicioOtro.value}
                            onChange={this.handleChange}
                            required={this.state.form.tipoServicioOtro.required}
                            label="¿Cuál?"
                          />
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.cargaKVA.key}
                          name={this.state.form.cargaKVA.key}
                          value={this.state.form.cargaKVA.value}
                          disabled={this.state.form.cargaKVA.disabled}
                          onChange={this.handleChange}
                          required={this.state.form.cargaKVA.required}
                          label="Carga existente en kVA"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.cargaKVAMax.key}
                          name={this.state.form.cargaKVAMax.key}
                          value={this.state.form.kva.value}
                          onChange={this.handleChange}
                          required={this.state.form.cargaKVAMax.required}
                          label="Carga máxima requerida en kVA"
                          disabled="true"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Nivel de tensión solicitado</InputLabel>
                          <Select
                            id={this.state.form.nivelTensionSolicitado.key}
                            name={this.state.form.nivelTensionSolicitado.key}
                            value={this.state.form.nivelTension.value}
                            onChange={this.handleChange}
                            label="Tipo de Uso"
                            required={true}
                            variant="outlined"
                            disabled="true"
                          >
                            {this.state.loadData.nivelesTension.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.id}>
                                  {val.nombre} - {val.descripcion}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <AppInputNumber
                          id={this.state.form.numeroMedidor.key}
                          name={this.state.form.numeroMedidor.key}
                          value={this.state.form.numeroMedidor.value}
                          label="Número Medidor"
                          onChange={this.handleChange}
                          required={this.state.form.numeroMedidor.required}
                          disabled={this.state.form.numeroMedidor.disabled}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <AppInputText
                          id={this.state.form.marcaMedidior.key}
                          name={this.state.form.marcaMedidior.key}
                          value={this.state.form.marcaMedidior.value}
                          onChange={this.handleChange}
                          required={this.state.form.marcaMedidior.required}
                          label="Marca"
                          disabled={this.state.form.marcaMedidior.disabled}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de medidor</InputLabel>
                          <Select
                            labelId="tipoMedidor"
                            id={this.state.form.tipoMedidor.key}
                            name={this.state.form.tipoMedidor.key}
                            value={this.state.form.tipoMedidor.value}
                            disabled={this.state.form.tipoMedidor.disabled}
                            onChange={this.handleChange}
                            required={true}
                            variant="outlined"
                          >
                            {this.state.loadData.tipoMedidor.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.tipo_medidor_id}>
                                  {val.tipo_medidor_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de medida</InputLabel>
                          <Select
                            labelId="tipoMedidor"
                            id={this.state.form.tipoMedida.key}
                            name={this.state.form.tipoMedida.key}
                            value={this.state.form.tipoMedida.value}
                            disabled={this.state.form.tipoMedida.disabled}
                            onChange={this.handleChange}
                            required={true}
                            variant="outlined"
                          >
                            {this.state.loadData?.tipoMedida.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.id}>
                                  {val.nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">Tipo de Acometida</InputLabel>
                          <Select
                            labelId="tipoAcometida"
                            id={this.state.form.tipoAcometida.key}
                            name={this.state.form.tipoAcometida.key}
                            value={this.state.form.tipoAcometida.value}
                            disabled={this.state.form.tipoAcometida.disabled}
                            onChange={this.handleChange}
                            required={true}
                            variant="outlined"
                          >
                            {this.state.loadData.tipoAcometida.map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.tipo_acometida_id}>
                                  {val.tipo_acometida_nombre}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <AppInputDate
                          id={this.state.form.fechaEntradaOperacion.key}
                          name={this.state.form.fechaEntradaOperacion.key}
                          value={this.state.form.fechaEntradaOperacion.value}
                          disabled={this.state.form.fechaEntradaOperacion.disabled}
                          label="Fecha entrada de operación"
                          onChange={this.handleChange}
                          required={this.state.form.fechaEntradaOperacion.required}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">El proyecto incluye algún sistema de generación?</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.incluyeSistemaGeneracion.key}
                            name={this.state.form.incluyeSistemaGeneracion.key}
                            value={this.state.form.incluyeSistemaGeneracion.value}
                            disabled={this.state.form.incluyeSistemaGeneracion.disabled}
                            onChange={this.handleChange}
                            required={true}
                            variant="outlined"
                          >
                            {[
                              { value: 1, detalle: 'Si' },
                              {
                                value: 0,
                                detalle: 'No',
                              },
                            ].map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.detalle}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      {this.state.isVisibleLinkGREG ? (
                        <Grid item xs={12} sm={12}>
                          <strong>
                            {' '}
                            Una vez concluida el proceso de legalización de una cuenta nueva, debe continuar con el proceso de establecido en la resolución Creg
                            174 de 2021 para Autogeneradores a pequeña a escala y a gran escala.{' '}
                          </strong>{' '}
                          <a href="http://35.184.36.98/eh_generacion_distribuida" target="_blank" rel="noopener noreferrer">
                            Aquí
                          </a>
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={4}>
                        <FormControl required variant="outlined" style={{ width: '100%' }}>
                          <InputLabel id="demo-simple-select-outlined-label">¿Necesidad de certificación RETIE?</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id={this.state.form.certificacionRETIE.key}
                            name={this.state.form.certificacionRETIE.key}
                            value={this.state.form.certificacionRETIE.value}
                            disabled={this.state.form.certificacionRETIE.disabled}
                            onChange={this.handleChange}
                            variant="outlined"
                          >
                            {[
                              { value: 1, detalle: 'Si' },
                              {
                                value: 0,
                                detalle: 'No',
                              },
                            ].map((val, index) => {
                              return (
                                <MenuItem key={index} value={val.value}>
                                  {val.detalle}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TableCuentaTipo
                          disabled={this.state.form.registrocuentatipo.disabled}
                          data={this.state.form.registrocuentatipo.value}
                          onSetRegistrocuentatipo={(e) => this.onSetRegistrocuentatipo(e)}
                        ></TableCuentaTipo>
                      </Grid>
                    </Grid>
                  </fieldset>
                ) : null}

                <fieldset
                  style={{
                    width: '97.5%',
                    textAlign: 'justify',
                    fontSize: '14px',
                  }}
                >
                  <legend>Observación</legend>
                  <Grid item xs={12} sm={12}>
                    <AppTextArea
                      id={this.state.form.observacion.key}
                      name={this.state.form.observacion.key}
                      value={this.state.form.observacion.value}
                      disabled={this.state.form.observacion.disabled}
                      label=""
                      onChange={this.handleChange}
                      helperText={`${this.state.form.observacion.value.length}/100`}
                    />
                  </Grid>
                </fieldset>

                <fieldset
                  style={{
                    width: '97.5%',
                    textAlign: 'justify',
                    fontSize: '14px',
                  }}
                >
                  <legend>
                    <strong>Señor propietario y constructor con la presentación de este formato y solicitud usted:</strong>
                  </legend>
                  <div style={{ marginTop: '10px' }}>
                    {' '}
                    <strong>-</strong> Declara que la información presentada en este documento y sus anexos es veraz y corresponde a la realidad del proyecto.
                  </div>
                  <br />
                  <div>
                    <strong>-</strong>Autoriza a Electrohuila S.A. E.S.P. , a verificar y consultar con las entidades competentes la existencia y veracidad de
                    la información por usted aportada.
                  </div>
                  <br />
                  <div>
                    <strong>-</strong> Mediante la suscripción del presente documento usted acepta que Electrohuila S.A. E.S.P. trate sus datos personales para
                    los fines relacionados con la prestación del servicio público de energía eléctrica, en los términos de la Ley 1581 de 2012, el contrato del
                    servicio público de energía eléctrica, la Ley 142 de 1994 y la política de tratamiento de datos personales vigente.
                  </div>
                  <br />
                  <strong>-</strong> ¿Acepta el tratamiento de sus datos personales en los términos de la Ley 1581 de 2012 y la política de tratamiento de datos
                  personales vigente para los fines relacionados con ofrecimiento de productos y servicios distintos de energía eléctrica de Electrohuila S.A.
                  E.S.P.?{' '}
                  <AppCheckbox
                    id={this.state.form.autorizaDatosPersonales.key}
                    name={this.state.form.autorizaDatosPersonales.key}
                    value={this.state.form.autorizaDatosPersonales.value}
                    required={this.state.form.autorizaDatosPersonales.required}
                    onChange={this.handleChangeCheck}
                  ></AppCheckbox>
                  {this.state.form.autorizaDatosPersonales.value ? '' : <label style={{ color: 'red' }}>*</label>}
                  <br />
                  <div>
                    <strong>-</strong>Declara conocer que según el capítulo VII, literales 8,9 y 10 del Contrato de Servicio Público de Energía Eléctrica son
                    causales de suspensión del servicio: Adulterar las conexiones y aparatos de medida o de control, o alterar el normal funcionamiento de estos
                    sin autorización de la ELECTROHUILA SA ESP, Dar al servicio público domiciliario un uso distinto al convenido con la ELECTROHUILA SA ESP,
                    Proporcionar el servicio a otro inmueble en forma temporal o permanente.
                  </div>
                  <br />
                  <strong>-</strong> La autorización para la conexión está condicionada a la verificación de la documentación suministrada por el cliente,
                  Electrohuila se reserva la el derecho de conexión en caso de detectar situación anómala o de conexion ilegal del servicio. ¿Autoriza recibir
                  las comunicaciones y notificaciones a través de medios electrónicos (email, sms, etc)?.{' '}
                  <AppCheckbox
                    id={this.state.form.autorizaConexion.key}
                    name={this.state.form.autorizaConexion.key}
                    value={this.state.form.autorizaConexion.value}
                    required={this.state.form.autorizaConexion.required}
                    onChange={this.handleChangeCheck}
                  ></AppCheckbox>
                  {this.state.form.autorizaConexion.value ? '' : <label style={{ color: 'red' }}>*</label>}
                  <br />
                  <OwnerEngineerWarning></OwnerEngineerWarning>
                </fieldset>

                <Grid item xs={12}>
                  <p style={{ fontStyle: 'italic' }}>Los campos marcados con [*] son obligatorios.</p>
                </Grid>

                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="secondary" size="large" startIcon={<Icon>check</Icon>} style={{ margin: '10px' }}>
                    {this.state.form.isUpdateCuentaNueva.value ? 'Actaulizar' : 'Radicar'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </OwnerEngineerValidator>
        </Card>

        <Dialog onClose={this.handleCloseDialog} aria-labelledby="customized-dialog-title" fullWidth={true} maxWidth="xl" open={this.state.openDialog}>
          <GenerarDireccion
            onClose={this.handleCloseDialog}
            setDireccion={this.setDireccion}
            currentKey={this.state.currentKey}
            location={location}
            tipoZona={this.state.form.tipoZona.value === '' ? 'U' : this.state.form.tipoZona.value}
          />
        </Dialog>

        {/*
                <div>
                    <Map
                        googleMapURL={mapURL}
                        containerElement={<div style={{height: '400px'}} />}
                        mapElement={<div style={{height: '100%'}} />}
                        loadingElement={<p>Cargando mapa...</p>}
                    />
                </div>
                */}
      </div>
    );
  }
}

export default withRouter(CuentaNuevaForm);
